import victoryArtUrl from '../assets/settlement/victory.png'
import failureArtUrl from '../assets/settlement/reserve.png'
import logoArtUrl from '../assets/logo.png'
import SaveSlots from './SaveSlots'
import Cloud from './Cloud'
import { sourceMetrics, operationMetrics, joinedMetrics, resourceEstimate, durationText, computeText, bytesText, codeBytes } from './settlement'
import { drawMaxCabinet, drawMaxSlots, maxControls } from './draw-max-machine'
import { overloadsFor, machineForm, machineRows, isCollector, footprint, runCollector, collectorCode } from './machines'
import Tutorial from './Tutorial'
import { roomColors, toolColors } from './room-colors'
import { levels, tutorialLevel, evaluateDelivery } from './levels'
import { menuConfig, reloadConfig } from './menu-config'
import { drawMachineIcon, drawMenuIcon } from './icons'
import { appearance, cargoName, cargoText, recipe, readRecipe, factoryError } from './metaphors'
import { methods, execute, format } from './library'
const S = 56, dirs = [[1,0],[0,1],[-1,0],[0,-1]]
const BELT_SPEED = 1.5 // Tile progress per second, shared by cargo and tread marks.
const tools = [['select','漫游','↖'],['belt','传送带','→'],['source.array','批量','▣'],['erase','拆除','×']]
const key = (x,y) => `${x},${y}`
export default class Factory {
  constructor(canvas) {
    this.canvas=canvas; this.c=canvas.getContext('2d'); this.cam={x:0,y:0,z:0.85}; this.map=new Map(); this.items=[]; this.tool='select'; this.dir=0; this.total=0; this.time=0; this.buttons=[]; this.events=[]; this.pointers=new Map();this.category=0;this.tabOffsets=[0,0,0,0];this.workshop=0;this.tabRegions=[];this.result=null;this.history=[];this.liveOpen=window.innerWidth>=760
    this.undoHistory=[];this.redoHistory=[];this.level=0;this.levelComplete=false;this.mode='campaign';this.completed=new Set();this.tutorial=null;this.resetAttempt()
    this.ensureMissionSource()
    if(typeof Image!=='undefined'){this.victoryArt=new Image();this.victoryArt.src=victoryArtUrl;this.failureArt=new Image();this.failureArt.src=failureArtUrl;this.logoArt=new Image();this.logoArt.src=logoArtUrl}
    this.missionOpen=window.innerWidth>=window.innerHeight
    const refreshConfig=()=>reloadConfig().catch(()=>{})
    refreshConfig()
    this.configTimer=setInterval(refreshConfig,2000)
    this.on(window,'focus',refreshConfig)
    this.on(window,'resize',()=>{const wasPortrait=this.w<this.h;this.resize();if(!wasPortrait&&this.w<this.h){this.missionOpen=false;this.liveOpen=false;this.statsOpen=false;this.shortcutsOpen=false}if(wasPortrait||this.w<this.h)this.home()}); this.resize();this.home()
    this.on(canvas,'contextmenu',e=>e.preventDefault())
    this.on(canvas,'wheel',e=>{
      e.preventDefault();if(this.settlement||this.overloadPicker)return;if(this.tutorial)return;const row=!this.editor&&!this.help&&this.tabRegions.find(r=>e.clientX>=r.x&&e.clientX<=r.x+r.w&&e.clientY>=r.y&&e.clientY<=r.y+r.h)
      if(row)this.tabOffsets[row.index]=Math.max(0,Math.min(row.max,this.tabOffsets[row.index]+(Math.abs(e.deltaX)>Math.abs(e.deltaY)?e.deltaX:e.deltaY)))
      else if(!this.editor&&!this.help)this.zoom(e.deltaY<0?1.1:0.9,e.clientX,e.clientY)
    },{passive:false})
    this.on(canvas,'pointerdown',e=>this.down(e)); this.on(canvas,'pointermove',e=>this.move(e)); this.on(canvas,'pointerup',e=>this.up(e));this.on(canvas,'pointercancel',e=>this.up(e))
    this.on(canvas,'pointerleave',()=>{this.menuPointer=null;this.pointerPosition=null;this.hover=null})
    this.on(window,'keydown',e=>this.keyboard(e))
    this.on(window,'keyup',e=>this.moveKeys.delete(e.key.toLowerCase()))
    this.on(window,'blur',()=>this.moveKeys.clear())
    this.shortcutsOpen=window.innerWidth>=760;this.moveKeys=new Set()
    this.on(canvas,'paste',e=>{if(this.editor){e.preventDefault();if(this.editor.replace)this.editor.text='';this.editor.replace=false;this.editor.text+=e.clipboardData.getData('text');this.editor.error=''}})
    canvas.tabIndex=0
    this.last=performance.now();this.loop=now=>{const dt=Math.min((now-this.last)/1000,0.05);this.last=now;this.moveCamera(dt);if(!this.paused)this.update(dt);this.draw();this.frame=requestAnimationFrame(this.loop)};this.frame=requestAnimationFrame(this.loop)
    if(typeof document!=='undefined'){
      this.saveSlots=new SaveSlots(this);this.cloud=new Cloud(this)
      this.on(window,'pagehide',()=>this.saveSlots.flush())
    }
  }
  on(el,type,fn,opts){el.addEventListener(type,fn,opts);this.events.push(()=>el.removeEventListener(type,fn,opts))}
  resize(){this.w=window.innerWidth;this.h=window.innerHeight;this.dpr=Math.min(devicePixelRatio||1,2);this.canvas.width=this.w*this.dpr;this.canvas.height=this.h*this.dpr;this.small=this.w<760}
  home(){
    if(this.w<this.h){
      const source=[...this.map.values()].find(b=>b.missionSource),minX=Math.min(-56,source?source.x*S:-5*S),maxX=Math.max(112,source?(source.x+1)*S:-4*S),minY=Math.min(-56,source?source.y*S:0),maxY=Math.max(112,source?(source.y+1)*S:56)
      const top=100,bottom=Math.max(top+60,this.h-213),z=Math.min(.65,Math.max(1,this.w-40)/(maxX-minX),(bottom-top)/(maxY-minY))
      this.cam={x:(minX+maxX)/2,y:(minY+maxY)/2+(this.h/2-(top+bottom)/2)/z,z};return
    }
    this.cam={x:0,y:0,z:this.small?0.5:0.85}
  }
  world(x,y){return {x:(x-this.w/2)/this.cam.z+this.cam.x,y:(y-this.h/2)/this.cam.z+this.cam.y}}
  cell(x,y){const p=this.world(x,y);return {x:Math.floor(p.x/S),y:Math.floor(p.y/S)}}
  zoom(f,x=this.w/2,y=this.h/2){const a=this.world(x,y);this.cam.z=Math.max(0.3,Math.min(2.2,this.cam.z*f));const b=this.world(x,y);this.cam.x+=a.x-b.x;this.cam.y+=a.y-b.y}
  down(e){e.preventDefault();
    if(['cloud','saves'].includes(this.help)){
      const button=this.buttons.slice().reverse().find(b=>e.clientX>=b.x&&e.clientX<=b.x+b.w&&e.clientY>=b.y&&e.clientY<=b.y+b.h)
      if(button)button.fn();return
    }
    if(this.editor&&this.editor.b.type==='source.number'&&this.numericField){const f=this.numericField;if(e.clientX>=f.x&&e.clientX<=f.x+f.w&&e.clientY>=f.y&&e.clientY<=f.y+f.h){this.canvas.setPointerCapture(e.pointerId);this.numericSelecting=e.pointerId;this.positionNumberCaret(e.clientX,e.shiftKey);return}}
    this.canvas.focus();this.canvas.setPointerCapture(e.pointerId);
    this.menuPointer=null
    this.pointerPosition=e.pointerType==='touch'?null:{x:e.clientX,y:e.clientY}
    if(this.settlement){const button=this.buttons.slice().reverse().find(b=>e.clientX>=b.x&&e.clientX<=b.x+b.w&&e.clientY>=b.y&&e.clientY<=b.y+b.h);if(button)button.fn();return}
    if(this.tutorial&&!this.tutorial.allows(e.clientX,e.clientY)){
      const control=this.buttons.slice().reverse().find(b=>b.tutorialControl&&e.clientX>=b.x&&e.clientX<=b.x+b.w&&e.clientY>=b.y&&e.clientY<=b.y+b.h)
      if(control)control.fn();return
    }
    const row=!this.editor&&!this.help&&this.tabRegions.find(r=>e.clientX>=r.x&&e.clientX<=r.x+r.w&&e.clientY>=r.y&&e.clientY<=r.y+r.h)
    if(row){this.tabDrag={id:e.pointerId,row,startX:e.clientX,startY:e.clientY,offset:this.tabOffsets[row.index],moved:false,button:this.buttons.find(b=>b.tab===row.index&&e.clientX>=b.x&&e.clientX<=b.x+b.w&&e.clientY>=b.y&&e.clientY<=b.y+b.h)};return}
    const b=this.buttons.slice().reverse().find(b=>e.clientX>=b.x&&e.clientX<=b.x+b.w&&e.clientY>=b.y&&e.clientY<=b.y+b.h);if(b){b.fn();return}if(this.editor||this.overloadPicker)return;if(this.help){this.help=false;return}this.pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});this.pan=this.tool==='select'&&e.button!==2||e.button===1;this.downPoint={x:e.clientX,y:e.clientY};this.erase=e.button===2;if(this.pointers.size>1)this.mapMove=null;if(this.pointers.size===1&&this.tool==='select'&&e.button===0){const cell=this.cell(e.clientX,e.clientY),building=this.buildingAt(cell.x,cell.y);if(building){this.mapMove={id:e.pointerId,building,from:cell,startX:e.clientX,startY:e.clientY,active:false};this.pan=false;return}}if(this.pointers.size===1&&!this.pan){const cell=this.cell(e.clientX,e.clientY);if(this.tool==='belt'&&!this.erase)this.beginBelt(cell);else this.place(cell)}}
  move(e){
    this.menuPointer=e.pointerType==='touch'?null:{x:e.clientX,y:e.clientY}
    this.pointerPosition=this.menuPointer
    if(this.settlement)return
    if(this.numericSelecting===e.pointerId){this.positionNumberCaret(e.clientX,true);return}
    if(this.mapMove&&this.mapMove.id===e.pointerId){const drag=this.mapMove;if(Math.hypot(e.clientX-drag.startX,e.clientY-drag.startY)>6)drag.active=true;this.hover=this.dragTarget(drag,e.clientX,e.clientY);this.pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});return}
    if(this.tutorial&&this.tabDrag)return
    if(this.tabDrag&&this.tabDrag.id===e.pointerId){const d=this.tabDrag,dx=e.clientX-d.startX;if(Math.hypot(dx,e.clientY-d.startY)>6)d.moved=true;this.tabOffsets[d.row.index]=Math.max(0,Math.min(d.row.max,d.offset-dx));return}
    this.hover=this.cell(e.clientX,e.clientY);const old=this.pointers.get(e.pointerId);if(!old)return;if(this.pointers.size===2){const other=[...this.pointers.entries()].find(([id])=>id!==e.pointerId)[1];const a=Math.hypot(old.x-other.x,old.y-other.y),b=Math.hypot(e.clientX-other.x,e.clientY-other.y);if(a>5)this.zoom(b/a,(e.clientX+other.x)/2,(e.clientY+other.y)/2)}else if(this.pan){this.cam.x-=(e.clientX-old.x)/this.cam.z;this.cam.y-=(e.clientY-old.y)/this.cam.z}else if(this.tool==='belt'&&!this.erase)this.paintBelts(this.hover);this.pointers.set(e.pointerId,{x:e.clientX,y:e.clientY})}
  up(e){
    if(this.numericSelecting===e.pointerId){this.numericSelecting=null;return}
    if(this.mapMove&&this.mapMove.id===e.pointerId){const drag=this.mapMove;this.mapMove=null;this.pointers.delete(e.pointerId);if(e.type!=='pointercancel'){if(drag.active&&this.isMapDropPoint(e.clientX,e.clientY))this.moveBuilding(drag.building,this.dragTarget(drag,e.clientX,e.clientY));else if(!drag.active&&methods[drag.building.type])this.edit(drag.building)}this.pan=false;this.downPoint=null;return}
    if(this.tabDrag&&this.tabDrag.id===e.pointerId){const d=this.tabDrag;this.tabDrag=null;if(e.type!=='pointercancel'&&!d.moved&&d.button)d.button.fn();return}
    if(e.type!=='pointercancel'&&this.pointers.has(e.pointerId)&&this.tool==='belt'&&!this.pan&&!this.erase)this.paintBelts(this.cell(e.clientX,e.clientY))
    this.finishBeltUndo();this.pointers.delete(e.pointerId);this.placed=null;this.dragCell=null;this.dragPath=null;this.dragBefore=null;this.dragStopped=false
  }
  beginBelt(p){
    this.dragPath=[];this.dragBefore=new Map();this.dragStopped=false;this.dragStartDir=this.dir
    if(this.buildingAt(p.x,p.y)?.missionSource){this.dragStopped=true;this.missionSourceNotice();return}
    if(Math.abs(p.x)<=1&&Math.abs(p.y)<=1){this.dragStopped=true;return}
    this.beltUndoBefore=this.mapSnapshot()
    this.dragBefore.set(key(p.x,p.y),this.map.get(key(p.x,p.y)))
    this.place(p);this.dragPath.push({...p});this.dragCell={...p}
  }
  paintBelts(target){
    if(this.dragStopped){
      if(!this.dragPath||!this.dragPath.some(p=>p.x===target.x&&p.y===target.y))return
      this.dragStopped=false
    }
    if(!this.dragPath||!this.dragPath.length){this.beginBelt(target);return}
    let {x,y}=this.dragPath[this.dragPath.length-1]
    const dx=target.x-x,dy=target.y-y,sx=Math.sign(dx),sy=Math.sign(dy)
    const stepX=dx?1/Math.abs(dx):Infinity,stepY=dy?1/Math.abs(dy):Infinity
    let edgeX=stepX/2,edgeY=stepY/2
    while(x!==target.x||y!==target.y){
      let dir
      if(x!==target.x&&(y===target.y||edgeX<=edgeY)){dir=sx>0?0:2;edgeX+=stepX}else{dir=sy>0?1:3;edgeY+=stepY}
      const nx=x+dirs[dir][0],ny=y+dirs[dir][1],k=key(nx,ny)
      const existingIndex=this.dragPath.findIndex(p=>p.x===nx&&p.y===ny)
      if(existingIndex>=0){
        // Retraction removes the tail instead of pointing two belts at each other.
        for(const p of this.dragPath.splice(existingIndex+1)){
          const old=this.dragBefore.get(key(p.x,p.y));this.removeBuilding(p)
          if(old)this.map.set(key(p.x,p.y),old)
          this.dragBefore.delete(key(p.x,p.y))
        }
        const tail=this.map.get(k),prev=this.dragPath[this.dragPath.length-2]
        this.dir=prev?dirs.findIndex(([dx,dy])=>prev.x+dx===nx&&prev.y+dy===ny):this.dragStartDir
        if(tail&&tail.type==='belt')tail.dir=this.dir
      }else{
        const previous=this.buildingAt(x,y),next=this.buildingAt(nx,ny)
        if(previous&&previous.type==='belt')previous.dir=dir
        this.dir=dir
        // Existing machinery, existing tracks and the output station are endpoints.
        if(next||Math.abs(nx)<=1&&Math.abs(ny)<=1){this.dragStopped=true;return}
        this.dragBefore.set(k,undefined);this.placed=null;this.place({x:nx,y:ny});this.dragPath.push({x:nx,y:ny})
      }
      x=nx;y=ny;this.dragCell={x,y}
    }
  }
  place(p){
    if(Math.abs(p.x)<=1&&Math.abs(p.y)<=1)return
    const k=key(p.x,p.y);if(this.placed===k)return;this.placed=k
    if(this.erase||this.tool==='erase'){const existing=this.buildingAt(p.x,p.y);if(existing?.missionSource){this.missionSourceNotice();return}if(existing)this.recordUndo();this.removeBuilding(p);return}
    if(this.tool==='select')return
    if(this.tool!=='belt'&&!methods[this.tool]||!this.isToolAvailable(this.tool))return
    const building=this.placementBuilding(p)
    if(!this.fitsFootprint(building))return
    if(!this.canReplaceFootprint(building)){this.missionSourceNotice();return}
    if(this.beltUndoBefore===undefined)this.recordUndo()
    this.clearFootprint(building)
    this.map.set(k,building)
    if(this.tool==='source.number'||this.tool==='source.string'){
      if(this.tutorial&&this.tutorial.step===3.5&&this.tool==='source.string')this.tutorial.step=4
      this.edit(building);this.editor.justPlaced=true
    }
    if(this.tool!=='belt')this.tool='select'
  }
  mapSnapshot(){
    return JSON.stringify([...this.map].map(([cell,b])=>[cell,{x:b.x,y:b.y,type:b.type,args:b.args,dir:b.dir,rows:b.rows||1,variant:b.variant,missionSource:b.missionSource===true}]).sort(([a],[b])=>a.localeCompare(b)))
  }
  recordUndo(snapshot=this.mapSnapshot()){
    this.saveSlots?.markDirty()
    if(!this.undoHistory)this.undoHistory=[]
    this.undoHistory.push(snapshot);if(this.undoHistory.length>100)this.undoHistory.shift()
    this.redoHistory=[]
    if(this.attemptArmed===false){this.attemptArmed=true;this.clearProduction()}
  }
  finishBeltUndo(){
    const before=this.beltUndoBefore;this.beltUndoBefore=undefined
    if(before!==undefined&&before!==this.mapSnapshot())this.recordUndo(before)
  }
  restoreOperation(snapshot){
    this.saveSlots?.markDirty()
    this.map=new Map(JSON.parse(snapshot).map(([cell,b])=>[cell,{...b,t:0}]))
    this.ensureMissionSource()
    this.items=[];this.result=null;this.history=[];this.delivery=null;this.editor=null;this.tool='select';this.mapMove=null;this.dragPath=null;this.dragBefore=null;this.dragCell=null;this.dragStopped=false;this.placed=null;this.tabDrag=null;this.beltUndoBefore=undefined
    this.pointers.clear();if(this.materialInput)this.materialInput.blur()
    if(this.attemptArmed===false)this.attemptArmed=true
  }
  undo(){
    this.finishBeltUndo();if(!this.undoHistory?.length)return
    const before=this.undoHistory.pop();if(!this.redoHistory)this.redoHistory=[]
    this.redoHistory.push(this.mapSnapshot());this.restoreOperation(before)
  }
  redo(){
    this.finishBeltUndo();if(!this.redoHistory?.length)return
    const next=this.redoHistory.pop();if(!this.undoHistory)this.undoHistory=[]
    this.undoHistory.push(this.mapSnapshot());this.restoreOperation(next)
  }
  dragTarget(drag,x,y){
    const cell=this.cell(x,y)
    return {x:cell.x-(drag.from.x-drag.building.x),y:cell.y-(drag.from.y-drag.building.y)}
  }
  buildingAt(x,y){
    const direct=this.map.get(key(x,y));if(direct)return direct
    for(const b of this.map.values())if(b.x===x&&y>b.y&&y<b.y+machineRows(b))return b
    return null
  }
  fitsFootprint(building){return footprint(building).every(p=>!(Math.abs(p.x)<=1&&Math.abs(p.y)<=1))}
  canReplaceFootprint(building,ignore=null){return footprint(building).every(p=>{const old=this.buildingAt(p.x,p.y);return !old?.missionSource||old===ignore})}
  clearFootprint(building){
    if(!this.canReplaceFootprint(building))return false
    const owners=new Set(footprint(building).map(p=>this.buildingAt(p.x,p.y)).filter(Boolean))
    owners.forEach(owner=>this.removeBuilding(owner))
    return true
  }
  placementBuilding(point){
    const form=this.sample&&this.sample.type===this.tool?this.sample:this.toolSetup&&this.toolSetup.type===this.tool?this.toolSetup:null
    const variant=form?form.variant:this.tool==='Math.max'?'numbers-2':undefined,rows=form?form.rows||1:this.tool==='Math.max'?2:1
    return {...point,type:this.tool,args:this.placementArgs(this.tool),variant,rows,dir:rows>1||variant&&variant.startsWith('numbers-')?(this.dir===2?2:0):this.dir,t:0}
  }
  isMapDropPoint(x,y){
    return x>=0&&y>=0&&x<this.w&&y<this.h-147&&!this.buttons.some(b=>x>=b.x&&x<=b.x+b.w&&y>=b.y&&y<=b.y+b.h)&&!this.tabRegions.some(r=>x>=r.x&&x<=r.x+r.w&&y>=r.y&&y<=r.y+r.h)
  }
  moveBuilding(building,target){
    if(Math.abs(target.x)<=1&&Math.abs(target.y)<=1||target.x===building.x&&target.y===building.y||this.map.get(key(building.x,building.y))!==building)return false
    const moved={...building,x:target.x,y:target.y,t:0,error:null,inputs:undefined}
    if(!this.fitsFootprint(moved))return false
    if(!this.canReplaceFootprint(moved,building)){this.missionSourceNotice();return false}
    const stretch=building.type==='belt'?{remove:[],belts:[]}:this.stretchConnections(building,moved)
    if(!stretch)return false
    this.recordUndo();this.removeBuilding(building,true);this.clearFootprint(moved)
    stretch.remove.forEach(p=>this.removeBuilding(p))
    this.map.set(key(target.x,target.y),moved)
    stretch.belts.forEach(b=>this.map.set(key(b.x,b.y),b))
    if(stretch.belts.length)this.clearProduction()
    return true
  }
  stretchConnections(building,moved){
    const incoming=p=>dirs.map(([dx,dy])=>this.buildingAt(p.x+dx,p.y+dy)).filter(b=>b&&b!==building&&b.x+dirs[b.dir][0]===p.x&&b.y+dirs[b.dir][1]===p.y)
    const links=[],claimed=new Set()
    const collect=(first,output,row,side)=>{
      let current=first;const chain=[],seen=new Set()
      while(current?.type==='belt'){
        const k=key(current.x,current.y);if(seen.has(k))return false;seen.add(k);chain.push(current)
        if(output){
          const [dx,dy]=dirs[current.dir],next=this.buildingAt(current.x+dx,current.y+dy)
          if(next?.type!=='belt'||incoming(next).length!==1)break
          current=next
        }else{
          const previous=incoming(current);if(previous.length!==1||previous[0].type!=='belt')break
          current=previous[0]
        }
      }
      if(chain.some(b=>claimed.has(key(b.x,b.y))))return false
      chain.forEach(b=>claimed.add(key(b.x,b.y)))
      links.push({chain,anchor:chain[chain.length-1],output,row,side});return true
    }
    for(const cell of footprint(building))for(let side=0;side<4;side++){
      const [dx,dy]=dirs[side],neighbor=this.buildingAt(cell.x+dx,cell.y+dy)
      if(neighbor?.type==='belt'&&neighbor.dir===(side+2)%4&&!building.type.startsWith('source.')&&(!isCollector(building)||side===(building.dir+2)%4)){
        if(!collect(neighbor,false,cell.y-building.y,side))return null
      }
    }
    const [ox,oy]=dirs[building.dir],out=this.buildingAt(building.x+ox,building.y+oy)
    if(out?.type==='belt'&&!collect(out,true,0,building.dir))return null
    if(!links.length)return {remove:[],belts:[]}
    const remove=links.flatMap(link=>link.chain.slice(0,-1)),free=new Set(remove.map(b=>key(b.x,b.y))),body=new Set(footprint(moved).map(p=>key(p.x,p.y))),reserved=new Set(),belts=[]
    const path=(start,end)=>{
      const startKey=key(start.x,start.y),endKey=key(end.x,end.y),queue=[start],parents=new Map([[startKey,null]]),margin=12
      const allowed=p=>{const k=key(p.x,p.y),b=this.buildingAt(p.x,p.y);return !body.has(k)&&!(Math.abs(p.x)<=1&&Math.abs(p.y)<=1)&&!reserved.has(k)&&(!b||b===building||free.has(k)||(k===endKey||k===startKey)&&claimed.has(k))}
      if(!allowed(start)||!allowed(end))return null
      for(let index=0;index<queue.length&&index<12000;index++){
        const p=queue[index],k=key(p.x,p.y)
        if(k===endKey){const result=[];let cursor=p;while(cursor){result.push(cursor);cursor=parents.get(key(cursor.x,cursor.y))}return result.reverse()}
        const steps=dirs.map(([dx,dy])=>({x:p.x+dx,y:p.y+dy})).sort((a,b)=>Math.abs(a.x-end.x)+Math.abs(a.y-end.y)-Math.abs(b.x-end.x)-Math.abs(b.y-end.y))
        for(const next of steps){const nk=key(next.x,next.y);if(parents.has(nk)||next.x<Math.min(start.x,end.x)-margin||next.x>Math.max(start.x,end.x)+margin||next.y<Math.min(start.y,end.y)-margin||next.y>Math.max(start.y,end.y)+margin||!allowed(next))continue;parents.set(nk,p);queue.push(next)}
      }
      return null
    }
    for(const link of links){
      const [dx,dy]=dirs[link.side],port={x:moved.x,y:moved.y+link.row},adjacent={x:port.x+dx,y:port.y+dy}
      if(body.has(key(link.anchor.x,link.anchor.y)))return null
      const route=link.output?path(adjacent,link.anchor):path(link.anchor,adjacent)
      if(!route)return null
      route.forEach((p,index)=>{
        const next=route[index+1]||(!link.output?port:null),dir=next?dirs.findIndex(([sx,sy])=>p.x+sx===next.x&&p.y+sy===next.y):link.anchor.dir
        belts.push({x:p.x,y:p.y,type:'belt',args:[],dir,t:0});reserved.add(key(p.x,p.y))
      })
    }
    return {remove,belts}
  }
  placementArgs(type){
    const input=this.currentMission().input
    return methods[type]?JSON.parse(JSON.stringify(this.sample&&this.sample.type===type?this.sample.args:this.toolSetup&&this.toolSetup.type===type?this.toolSetup.args:type==='source.number'?0:type==='source.string'?'':input&&input.type===type?input.value:methods[type].args)):[]
  }
  removeBuilding(p,allowMissionSource=false){
    const old=this.buildingAt(p.x,p.y);if(!old)return
    if(old.missionSource&&!allowMissionSource){this.missionSourceNotice();return false}
    this.map.delete(key(old.x,old.y))
    const cells=new Set(footprint(old).map(p=>key(p.x,p.y)))
    this.items=this.items.filter(item=>!cells.has(key(item.x,item.y)))
    if(this.editor&&this.editor.b===old)this.editor=null
    old.inputs=undefined
  }
  keyboard(e){
    if(this.help==='saves'){this.saveSlots.keyboard(e);return}
    if(this.help==='cloud'){this.cloud.keyboard(e);return}
    if(this.settlement){if(e.key==='Escape'){e.preventDefault();if(this.settlement.failed)this.retryMission();else this.optimizeMission()}else if(e.key==='Enter'&&!e.repeat){e.preventDefault();this.settlementNext()}else if((e.ctrlKey||e.metaKey)&&e.key.toLowerCase()==='s'){e.preventDefault();this.save()}return}
    if(this.editor&&this.editor.native){
      if(e.key==='Escape'){e.preventDefault();this.cancelMaterialEditor()}
      else if(e.key==='Enter'&&(this.editor.b.type==='source.number'||e.ctrlKey||e.metaKey)){e.preventDefault();this.commitEditor()}
      return
    }
    if(this.overloadPicker){if(e.key==='Escape')this.overloadPicker=null;return}
    if(this.orderBook){if(e.key==='Escape')this.orderBook=false;return}
    if(this.tutorial&&!this.editor){if(e.key==='Escape')this.tutorial=null;return}
    if((e.ctrlKey||e.metaKey)&&e.key.toLowerCase()==='s'){e.preventDefault();if(!this.editor)this.save();return}
    if(this.editor){
      if(e.key==='Escape'){this.editor=null;return}
      if(e.key==='Enter'){e.preventDefault();if(e.shiftKey){if(this.editor.replace)this.editor.text='';this.editor.replace=false;this.editor.text+='\n'}else this.commitEditor();return}
      if((e.ctrlKey||e.metaKey)&&e.key.toLowerCase()==='a'){e.preventDefault();this.editor.replace=true;return}
      if(e.key==='Backspace'){e.preventDefault();this.editor.text=this.editor.replace?'':this.editor.text.slice(0,-1);this.editor.replace=false}
      else if(e.key==='Tab'){e.preventDefault();this.editor.active=(this.editor.active+1)%Math.max(1,this.editor.fields.length);this.editor.replace=true}
      else if(e.key.length===1&&!e.ctrlKey&&!e.metaKey){e.preventDefault();if(this.editor.replace)this.editor.text='';this.editor.replace=false;this.editor.text+=e.key}
      return
    }
    if((e.ctrlKey||e.metaKey)&&['c','y'].includes(e.key.toLowerCase())){e.preventDefault();if(!e.repeat){if(e.key.toLowerCase()==='c')this.undo();else this.redo()}return}
    if(!e.ctrlKey&&!e.metaKey&&['w','a','s','d'].includes(e.key.toLowerCase())){e.preventDefault();this.moveKeys.add(e.key.toLowerCase())}
    if(e.repeat)return
    if(e.key.toLowerCase()==='q'&&this.hover){const b=this.buildingAt(this.hover.x,this.hover.y);if(b&&this.isToolAvailable(b.type)){this.tool=b.type;this.dir=b.dir;this.sample={type:b.type,args:JSON.parse(JSON.stringify(b.args)),rows:machineRows(b),variant:b.variant};return}}
    if(e.key.toLowerCase()==='l'&&!e.ctrlKey&&!e.metaKey){this.load();return}
    if(e.key==='F1'){e.preventDefault();this.toggleShortcuts();return}
    const n=Number(e.key);if(n>=1&&n<=4&&this.isToolAvailable(tools[n-1][0]))this.tool=tools[n-1][0]
    if(e.key.toLowerCase()==='r')this.dir=methods[this.tool]&&isCollector(this.placementBuilding({x:0,y:0}))?(this.dir===2?0:2):(this.dir+1)%4
    if(e.code==='Space'){e.preventDefault();this.paused=!this.paused}
    if(e.key==='Escape'){this.help=false;this.tool='select';this.mapMove=null;this.pointers.clear()}
    if(e.key.toLowerCase()==='h')this.home()
  }
  edit(b){
    if(b.missionSource){this.missionSourceNotice();return}
    this.moveKeys.clear()
    const form=isCollector(b)?{fields:[],decode:()=>b.args}:recipe(b.type,b.args)
    this.editor={b,...form,active:0,replace:true,error:'',get text(){return this.fields[this.active]?this.fields[this.active].value:''},set text(v){const f=this.fields[this.active];if(f&&f.kind!=='choice')f.value=v}}
    if(b.type==='source.number'||b.type==='source.string')this.focusMaterialInput()
  }
  focusMaterialInput(){
    if(typeof document==='undefined')return
    if(!this.materialInput){
      const input=document.createElement('textarea');input.setAttribute('aria-label','编辑物料内容');input.style.cssText='position:fixed;left:0;top:0;width:1px;height:1px;opacity:0;pointer-events:none;z-index:-1;';document.body.appendChild(input);this.materialInput=input
      this.on(input,'input',()=>{if(this.editor){this.editor.text=input.value;this.editor.replace=false;this.editor.error=''}})
    }
    this.editor.native=true;this.materialInput.value=this.editor.text;this.materialInput.inputMode=this.editor.b.type==='source.number'?'decimal':'text';this.materialInput.focus({preventScroll:true});this.materialInput.select()
  }
  cancelMaterialEditor(){
    const ed=this.editor;this.editor=null;if(this.materialInput)this.materialInput.blur()
    if(ed&&this.tutorial&&this.tutorial.step===4){this.removeBuilding(ed.b);this.tool='source.string';this.tutorial.step=3.5}
  }
  commitEditor(){
    try{
      const ed=this.editor,value=readRecipe(ed)
      if(this.tutorial&&this.tutorial.step===4&&value!=='ok')throw new Error('第一份订单请填写 ok（小写字母）')
      if(!ed.justPlaced&&JSON.stringify(ed.b.args)!==JSON.stringify(value))this.recordUndo()
      this.saveSlots?.markDirty()
      ed.b.args=value;ed.b.error=null;this.editor=null;if(this.materialInput)this.materialInput.blur();this.items=[];for(const b of this.map.values()){b.t=0;b.error=null;b.inputs=undefined;b.visualBatch=undefined}
      if(ed.b.type==='source.number'||ed.b.type==='source.string')this.tool='select'
      if(this.tutorial&&this.tutorial.step===4)this.tutorial.step=5
    }catch(e){this.editor.error=e.message}
  }
  update(dt){
    if(this.settlement||this.editor||this.overloadPicker)return
    this.time+=dt
    const occupied=new Set(this.items.map(i=>key(i.x,i.y)))
    for(const b of this.map.values()){
      if(!b.type.startsWith('source.'))continue;b.t+=dt
      if(b.t>2.5&&!occupied.has(key(b.x,b.y))){
        const started=performance.now(),value=b.type==='source.date'?new Date(b.args):typeof b.args==='object'?JSON.parse(JSON.stringify(b.args)):b.args
        const metrics=sourceMetrics(value,performance.now()-started)
        this.items.push({origin:{type:b.type,value:JSON.parse(JSON.stringify(b.args))},route:[],metrics,x:b.x,y:b.y,value,code:b.type==='source.date'?'new Date('+JSON.stringify(b.args)+')':JSON.stringify(b.args),p:0});occupied.add(key(b.x,b.y));b.t=0
      }
    }
    this.items=this.items.filter(i=>{
      const b=this.buildingAt(i.x,i.y);if(!b)return false
      i.p+=dt*BELT_SPEED
      // Process only after the original cargo has disappeared inside the housing.
      if(isCollector(b)&&!i.processed&&i.p>=0.5){
        const slot=i.y-b.y;b.inputs=b.inputs||Array(machineRows(b)).fill(null)
        if(b.inputs[slot]){i.p=0.5;return true}
        b.inputs[slot]=i;occupied.delete(key(i.x,i.y));return false
      }
      if(b.type!=='belt'&&!b.type.startsWith('source.')&&!i.processed&&i.p>=0.5){
        try{const input=i.value,started=performance.now();i.value=execute(b.type,input,b.args);i.metrics=operationMetrics(i.metrics,input,i.value,performance.now()-started);if(b.type==='Math.max')b.visualBatch={values:[i.value],result:i.value};i.code=this.codeStep(i.code,b,i);i.route.push(b.type);i.processed=true;b.error=null}
        catch(e){b.error=factoryError(b.type);occupied.delete(key(i.x,i.y));return false}
      }
      if(i.p<1)return true
      const [dx,dy]=dirs[b.dir],x=i.x+dx,y=i.y+dy
      if(Math.abs(x)<=1&&Math.abs(y)<=1){this.total++;this.result={value:i.value,code:i.code,lines:i.lines||[]};this.delivery=evaluateDelivery(i,this.currentMission());if(this.delivery.ok&&this.attemptArmed!==false){this.levelComplete=true;if(this.mode==='campaign')this.completed.add(levels[this.level].id);if(!this.attemptFinished)this.completeAttempt(i)}else if(this.delivery.missing?.length&&this.attemptArmed!==false){this.failAttempt(this.delivery.missing)}this.history.unshift(format(i.value));this.history=this.history.slice(0,4);occupied.delete(key(i.x,i.y));return false}
      const next=this.buildingAt(x,y)
      if(next&&!next.type.startsWith('source.')&&!occupied.has(key(x,y))&&(!isCollector(next)||b.dir===next.dir&&!next.inputs?.[y-next.y])){
        occupied.delete(key(i.x,i.y));occupied.add(key(x,y));i.entry=(b.dir+2)%4;i.x=x;i.y=y;i.p-=1;i.processed=false
      }
      i.p=Math.min(1,i.p)
      return true
    })
    for(const b of this.map.values()){
      if(!isCollector(b)||!b.inputs||!b.inputs.every(Boolean)||occupied.has(key(b.x,b.y)))continue
      const inputs=b.inputs
      try{
        const started=performance.now(),value=runCollector(b.type,inputs.map(item=>item.value)),metrics=joinedMetrics(inputs,value,performance.now()-started)
        if(b.type==='Math.max')b.visualBatch={values:inputs.map(item=>item.value),result:value}
        this.items.push({x:b.x,y:b.y,p:0.5,entry:(b.dir+2)%4,processed:true,value,metrics,code:collectorCode(b.type,inputs),origin:inputs[0].origin,route:inputs.flatMap(item=>item.route||[]).concat(b.type)})
        occupied.add(key(b.x,b.y));b.inputs=undefined;b.error=null
      }catch(error){b.error=factoryError(b.type);b.inputs=undefined;b.visualBatch=undefined}
    }
  }
  codeStep(code,b,item){
    if(b.type==='keyword.const'||b.type==='keyword.let'){
      const lines=item.lines||(item.lines=[]),name='cargo'+(lines.length+1)
      lines.push(b.type.slice(8)+' '+name+' = '+code+';');return name
    }
    if(b.type==='Array.index'||b.type==='Object.get')return '('+code+')['+JSON.stringify(b.args[0])+']'
    if(b.type==='operator.multiply')return '('+code+') * '+(b.args[0]==='PI'?'Math.PI':JSON.stringify(b.args[0]))
    if(b.type==='Date.getUTCFullYear')return '('+code+').getUTCFullYear()'
    if(methods[b.type].property)return '('+code+').'+methods[b.type].label
    const args=b.args.map(v=>JSON.stringify(v)).join(', ')
    if(b.type==='Array.map'||b.type==='Array.filter'){const cb=b.args[0];return '('+code+').'+methods[b.type].label+'('+(['String','Number','Boolean'].includes(cb)?cb:'x => '+cb)+')'}
    if(b.type==='Array.reduce')return '('+code+').reduce((a, x) => a '+(b.args[0]==='sum'?'+':'*')+' x, '+JSON.stringify(b.args[1])+')'
    if(b.type.startsWith('Array.')||b.type.startsWith('String.')||b.type==='Number.toFixed')return '('+code+').'+methods[b.type].label+'('+args+')'
    if(b.type==='Math.max'||b.type==='Math.min')return b.type+'(...('+code+'))'
    return b.type+'('+code+(args?', '+args:'')+')'
  }
  save(){
    if(this.saveSlots){this.saveSlots.open('save');return}
    try{localStorage.setItem('factory-campaign-v1',JSON.stringify({version:2,mode:this.mode,attemptElapsedMs:this.elapsedAttempt(),attemptFinished:!!this.attemptFinished,completed:[...this.completed],level:this.level,levelComplete:this.levelComplete,map:[...this.map].map(([k,b])=>[k,{...b,error:null,inputs:undefined,visualBatch:undefined}])}));this.saveMessage='已手动保存'}catch(e){this.saveMessage='保存失败，请检查浏览器存储空间'}
    this.saveMessageUntil=performance.now()+2500
  }
  load(){
    if(this.saveSlots){this.saveSlots.open('load');return}
    const raw=localStorage.getItem('factory-campaign-v1')
    if(!raw){this.saveMessage='还没有保存的地图';this.saveMessageUntil=performance.now()+2500;return false}
    try{return this.restoreSnapshot(JSON.parse(raw))}catch(error){this.saveMessage='地图加载失败，当前地图已保留';return false}
  }
  captureSave(){return {version:2,mode:this.mode,attemptElapsedMs:this.elapsedAttempt(),attemptFinished:!!this.attemptFinished,completed:[...this.completed],level:this.level,levelComplete:this.levelComplete,map:JSON.parse(this.mapSnapshot())}}
  restoreSnapshot(data){
    try{
      if(!data||!Array.isArray(data.map)||!Number.isInteger(data.level)||data.level<0||data.level>=levels.length)throw new Error('invalid map')
      const restored=new Map()
      for(const entry of data.map){
        if(!Array.isArray(entry)||entry.length!==2||!entry[1])throw new Error('invalid cell')
        const [k,b]=entry
        if(!Number.isInteger(b.x)||!Number.isInteger(b.y)||k!==key(b.x,b.y)||restored.has(k)||Math.abs(b.x)<=1&&Math.abs(b.y)<=1||!Number.isInteger(b.dir)||b.dir<0||b.dir>3)throw new Error('invalid cell')
        const type=b.type==='source.pack'?(Array.isArray(b.args)?'source.array':'source.object'):b.type
        if(type!=='belt'&&!methods[type])throw new Error('invalid equipment')
        if(type==='source.number'&&(typeof b.args!=='number'||!Number.isFinite(b.args))||type==='source.string'&&typeof b.args!=='string'||type==='source.date'&&(typeof b.args!=='string'||Number.isNaN(new Date(b.args).getTime()))||type==='source.array'&&!Array.isArray(b.args)||type==='source.object'&&(!b.args||Array.isArray(b.args)||typeof b.args!=='object')||!type.startsWith('source.')&&type!=='belt'&&!Array.isArray(b.args))throw new Error('invalid recipe')
        const variant=b.variant,form=variant?machineForm(type,variant):null
        if(variant&&!form||b.rows!==undefined&&(!Number.isInteger(b.rows)||b.rows<1||b.rows>64)||form&&b.rows!==form.rows||b.rows>1&&!form||form?.collector&&![0,2].includes(b.dir))throw new Error('invalid footprint')
        const restoredBuilding={x:b.x,y:b.y,type,args:b.args===undefined?[]:b.args,variant,rows:form?form.rows:1,dir:b.dir,t:0,missionSource:b.missionSource===true}
        if(!this.fitsFootprint(restoredBuilding))throw new Error('invalid footprint')
        restored.set(k,restoredBuilding)
      }
      const cells=new Set();for(const b of restored.values())for(const p of footprint(b)){const cellKey=key(p.x,p.y);if(cells.has(cellKey))throw new Error('overlapping footprint');cells.add(cellKey)}
      this.ensureMissionSource(restored,data.level,data.version===2&&data.mode==='tutorial'?'tutorial':'campaign')
      // Apply only after the entire snapshot has passed validation.
      this.undoHistory=[];this.redoHistory=[];this.beltUndoBefore=undefined;this.tutorial=null;this.mapMove=null;this.mode=data.version===2&&data.mode==='tutorial'?'tutorial':'campaign';this.completed=new Set((data.version===2&&Array.isArray(data.completed)?data.completed:[]).filter(id=>levels.some(l=>l.id===id)));this.map=restored;this.level=data.level;this.levelComplete=this.mode==='campaign'?this.completed.has(levels[this.level].id):!!data.levelComplete;this.items=[];this.result=null;this.history=[];this.total=0;this.editor=null;this.tool='select';this.sample=null;this.placed=null;this.dragCell=null;this.dragPath=null;this.dragBefore=null;this.dragStopped=false;this.tabDrag=null;this.pointers.clear();this.moveKeys.clear();this.home()
      this.resetAttempt({elapsedMs:data.attemptFinished?0:data.attemptElapsedMs,armed:!this.levelComplete})
      this.saveMessage='已手动加载地图'
      this.saveMessageUntil=performance.now()+2500
      return true
    }catch(e){this.saveMessage='地图加载失败，当前地图已保留'}
    this.saveMessageUntil=performance.now()+2500
    return false
  }
  fitText(text,x,y,width,size=12,color='#607451',align='left'){
    let t=String(text);this.c.font=size+'px "Segoe UI","Microsoft YaHei",sans-serif'
    while(t.length>1&&this.c.measureText(t).width>width)t=t.slice(0,-2)+'…'
    this.text(t,x,y,size,color,align)
  }
  wrap(text,x,y,width,size=12,maxLines=5){
    this.c.font=size+'px "Segoe UI","Microsoft YaHei",sans-serif';let line='',row=0
    for(const ch of String(text)){if(ch==='\n'||this.c.measureText(line+ch).width>width){this.text(line,x,y+row*(size+7),size);line='';if(++row>=maxLines){this.text('…',x,y+row*(size+7),size);return}if(ch==='\n')continue}line+=ch}this.text(line,x,y+row*(size+7),size)
  }
  rect(x,y,w,h,fill,r=0,stroke){const c=this.c;c.beginPath();c.moveTo(x+r,y);c.arcTo(x+w,y,x+w,y+h,r);c.arcTo(x+w,y+h,x,y+h,r);c.arcTo(x,y+h,x,y,r);c.arcTo(x,y,x+w,y,r);c.closePath();if(fill){c.fillStyle=fill;c.fill()}if(stroke){c.strokeStyle=stroke;c.lineWidth=1;c.stroke()}}
  text(t,x,y,size=12,color='#7d8a73',align='left',weight=400){const c=this.c;c.font=`${weight} ${size}px "Segoe UI","Microsoft YaHei",sans-serif`;c.textAlign=align;c.textBaseline='middle';c.fillStyle=color;c.fillText(t,x,y)}
  shape(type,x,y,r=12,green=false){const c=this.c;c.beginPath();if(type==='square')c.rect(x-r,y-r,r*2,r*2);else if(type==='half'){c.arc(x,y,r,0,Math.PI);c.closePath()}else c.arc(x,y,r,0,Math.PI*2);c.fillStyle=green?'#83bd8b':'#fafcf6';c.strokeStyle=green?'#456d4c':'#73836a';c.lineWidth=2;c.fill();c.stroke()}
  button(x,y,w,h,label,fn,active=false){this.rect(x,y,w,h,active?'#e5eedb':'#fcfdf8',9,active?'#ffad24':'#d6dfce');if(active){this.c.lineWidth=2;this.c.stroke();this.c.lineWidth=1}this.text(label,x+w/2,y+h/2,13,'#5e7450','center',600);this.buttons.push({x,y,w,h,fn})}
  toggleTool(tool){
    if(!this.isToolAvailable(tool))return
    if(tool==='keyword.return'){this.home();this.returnFocusUntil=this.time+2;this.tool='select';return}
    if(tool==='keyword.function'){this.liveOpen=!this.liveOpen;this.tool='select';return}
    if(this.tool===tool){this.tool='select';return}
    if(tool==='Math.max'){this.sample=null;this.toolSetup={type:tool,variant:'numbers-2',rows:2,args:[]};this.tool=tool;return}
    const forms=overloadsFor(tool)
    if(forms.length){this.overloadPicker={type:tool,forms,page:0};this.tool='select';return}
    this.toolSetup=null;this.sample=null;this.tool=tool
  }
  visibleWorkshops(){
    const used=new Set(['source.number','source.string'])
    if(this.mode!=='tutorial')levels.filter((level,index)=>index===this.level||this.completed.has(level.id)).forEach(level=>{used.add(level.input.type);level.required.forEach(id=>used.add(id))})
    return menuConfig.workshops.map((workshop,index)=>({workshop,index})).filter(({workshop})=>workshop.children.some(room=>room.methods.some(method=>used.has(method.id))))
  }
  roomTabs(workshop){
    const used=new Set(['source.number','source.string'])
    const missions=this.mode==='tutorial'?[]:levels.filter((level,index)=>index===this.level||this.completed.has(level.id))
    missions.forEach(level=>{used.add(level.input.type);level.required.forEach(id=>used.add(id))})
    return workshop.children.map((room,index)=>({room,index,dimmed:!room.methods.some(method=>used.has(method.id))})).filter(tab=>!tab.room.methods.every(method=>method.id.startsWith('source.'))).sort((a,b)=>Number(a.dimmed)-Number(b.dimmed))
  }
  isToolAvailable(id){
    if(['belt','select','erase','keyword.function','keyword.return'].includes(id)||id.startsWith('source.')&&methods[id])return true
    return menuConfig.workshops.some(workshop=>this.roomTabs(workshop).some(tab=>tab.room.methods.some(method=>method.id===id)))
  }
  resetAttempt({elapsedMs=0,armed=true}={}){
    this.attemptStartedAt=performance.now();this.attemptElapsedBase=Number.isFinite(elapsedMs)&&elapsedMs>0?elapsedMs:0
    this.attemptFinished=false;this.attemptArmed=armed;this.settlement=null
    this.cloud?.beginAttempt()
  }
  elapsedAttempt(){return this.settlement?this.settlement.elapsedMs:(this.attemptElapsedBase||0)+Math.max(0,performance.now()-(this.attemptStartedAt??performance.now()))}
  clearProduction(){
    this.items=[]
    for(const b of this.map.values()){b.t=0;b.inputs=undefined;b.visualBatch=undefined;b.error=null}
  }
  completeAttempt(item){
    this.finishBeltUndo();this.attemptFinished=true
    const metrics=item.metrics||sourceMetrics(item.value),resources=resourceEstimate(this.map,this.items,item)
    this.settlement={elapsedMs:this.elapsedAttempt(),computeMs:metrics.computeMs,operations:metrics.operations,resources,codeBytes:codeBytes(this.mainCode()),name:this.currentMission().name}
    this.saveSlots?.markDirty();this.cloud?.complete(this.settlement)
    this.pointers?.clear();this.moveKeys?.clear();this.mapMove=null;this.dragPath=null;this.dragCell=null;this.tool='select'
  }
  failAttempt(missing){
    this.finishBeltUndo();this.settlement={failed:true,missing:[...new Set(missing)],elapsedMs:this.elapsedAttempt()}
    this.pointers?.clear();this.moveKeys?.clear();this.mapMove=null;this.dragPath=null;this.dragCell=null;this.tool='select'
  }
  retryMission(){
    const elapsedMs=this.elapsedAttempt();this.resetAttempt({elapsedMs,armed:false});this.clearProduction();this.tool='select'
  }
  optimizeMission(){
    this.settlement=null;this.tutorial=null;this.levelComplete=false;this.resetAttempt({armed:false});this.clearProduction();this.tool='select'
  }
  settlementNext(){
    if(this.settlement?.failed){this.retryMission();return}
    if(this.mode==='tutorial'||this.level<levels.length-1){this.settlement=null;this.nextLevel()}
    else{this.settlement=null;this.orderBook=true;this.orderPage=Math.floor(this.level/6)}
  }
  drawSettlement(){
    if(this.settlement.failed){this.drawFailedSettlement();return}
    const stats=this.settlement,c=this.c,w=Math.min(530,this.w-24),h=Math.min(590,this.h-24),x=(this.w-w)/2,y=(this.h-h)/2,compact=h<400
    const artSize=Math.min(210,Math.max(64,(h-300)*.8),w-60),top=artSize+50,rowH=Math.min(64,Math.max(24,(h-top-(h>=470?130:95))/3))
    c.save();c.fillStyle='#24352b99';c.fillRect(0,0,this.w,this.h);c.shadowColor='#1d352733';c.shadowBlur=30;c.shadowOffsetY=12
    this.rect(x,y,w,h,'#ffffff',18,'#d4dfc9');c.shadowBlur=0;c.shadowOffsetY=0
    if(this.victoryArt?.complete&&this.victoryArt.naturalWidth)c.drawImage(this.victoryArt,x+(w-artSize)/2,y+8,artSize,artSize)
    else this.text(this.mode==='tutorial'?'第一单，完成了！':'订单完成！',x+w/2,y+artSize/2,23,'#466337','center',700)
    const rows=[['你花的时间',durationText(stats.elapsedMs)],['运算耗时',computeText(stats.computeMs)],['内存 / 资源（估算）',bytesText(stats.resources.bytes)]]
    rows.forEach(([label,value],index)=>{
      const rowY=y+top+index*rowH
      this.rect(x+18,rowY,w-36,rowH-5,index%2?'#f5f7ef':'#edf2e5',8)
      this.text(label,x+30,rowY+(rowH-5)/2,compact?12:14,'#7b8d6e')
      this.text(value,x+w-30,rowY+(rowH-5)/2,compact?16:21,'#47613b','right',600)
    })
    if(this.mode==='campaign'){
      const comparisons=stats.cloudResult?.comparisons,labels=[['code','代码体积'],['compute','运算耗时'],['memory','资源占用']]
      if(comparisons)labels.forEach(([id,label],index)=>{
        const value=comparisons[id],message=value?.beaten!=null?'打败全服 '+value.beaten.toFixed(1)+'% 的人':value?.rank?'并列成绩，暂无法比较':'未进入前100名'
        this.fitText(label+' · '+message,x+w/2,y+h-116+index*17,w-36,11,'#738667','center')
      })
      else this.fitText(this.cloud?.user?'正在复核全服排名…':'上榜后查看打败全服多少人',x+w/2,y+h-83,w-36,12,'#738667','center')
    }
    this.buttons=[];this.tabRegions=[]
    if(this.cloud&&!this.cloud.user)this.button(x+w-110,y+16,92,32,'我要上榜',()=>this.cloud.openAccount())
    const buttonW=(w-52)/2
    this.button(x+22,y+h-58,buttonW,38,'继续优化',()=>this.optimizeMission())
    this.button(x+30+buttonW,y+h-58,buttonW,38,this.mode==='campaign'&&this.level===levels.length-1?'订单簿':'下一关',()=>this.settlementNext(),true)
    c.restore()
  }
  drawFailedSettlement(){
    const missing=this.settlement.missing,c=this.c,w=Math.min(440,this.w-24),columns=Math.max(1,Math.floor((w-40)/70)),rows=Math.ceil(missing.length/columns),h=Math.min(this.h-24,370+rows*70),x=(this.w-w)/2,y=(this.h-h)/2,artSize=Math.max(60,Math.min(190,h-210-rows*70))
    c.save();c.fillStyle='#24352b99';c.fillRect(0,0,this.w,this.h);this.rect(x,y,w,h,'#fffdf9',18,'#e6d9ce')
    if(this.failureArt?.complete&&this.failureArt.naturalWidth)c.drawImage(this.failureArt,x+(w-artSize)/2,y+12,artSize,artSize)
    else this.text('本次未通过',x+w/2,y+artSize/2,23,'#b36b43','center',700)
    this.fitText('货物未经指定道具加工，就到达了出货站。',x+w/2,y+artSize+42,w-32,14,'#8b796c','center')
    this.buttons=[];this.tabRegions=[]
    missing.forEach((id,index)=>{
      const left=x+(w-Math.min(columns,missing.length)*70+10)/2+index%columns*70,top=y+artSize+72+Math.floor(index/columns)*70,color=toolColors(id)
      this.rect(left,top,60,60,color.card,8,color.border);drawMachineIcon(c,id,left+30,top+23,30,color.ink,color.card)
      this.fitText(appearance(id).name,left+30,top+49,52,10,color.ink,'center')
    })
    this.button(x+22,y+h-58,w-44,38,'再试试吧',()=>this.retryMission(),true);c.restore()
  }
  currentMission(){return this.mode==='tutorial'?tutorialLevel:levels[this.level]}
  missionSourceNotice(){this.saveMessage='任务原料内容固定，可拖动位置，不能删除或替换';this.saveMessageUntil=performance.now()+3000}
  ensureMissionSource(map=this.map,level=this.level,mode=this.mode){
    if(mode!=='campaign'){for(const b of map.values())b.missionSource=false;return null}
    const input=levels[level]?.input;if(!input)return null
    const matches=b=>b.type===input.type&&JSON.stringify(b.args)===JSON.stringify(input.value)
    let source=[...map.values()].find(b=>b.missionSource&&matches(b))||[...map.values()].find(matches)
    for(const b of map.values())b.missionSource=false
    if(!source){
      let x=-5;const y=0
      while([...map.values()].some(b=>footprint(b).some(p=>p.x===x&&p.y===y)))x--
      source={x,y,type:input.type,args:JSON.parse(JSON.stringify(input.value)),dir:0,rows:1,t:0};map.set(key(x,y),source)
    }
    source.missionSource=true;return source
  }
  isMissionUnlocked(index,completed=this.completed){
    return Number.isInteger(index)&&index>=0&&index<levels.length&&levels.slice(0,index).every(level=>completed.has(level.id))
  }
  startMission(index,mode='campaign'){
    if(index<0||index>=levels.length)return
    if(mode==='campaign'&&!this.isMissionUnlocked(index))return false
    this.undoHistory=[];this.redoHistory=[];this.beltUndoBefore=undefined;this.mode=mode;this.level=index;this.levelComplete=mode==='campaign'&&this.completed.has(levels[index].id)
    this.tutorial=null;this.map.clear();this.items=[];this.result=null;this.history=[];this.total=0;this.delivery=null;this.editor=null;this.tool='select';this.sample=null;this.orderBook=false;this.mapMove=null;this.toolSetup=null;this.overloadPicker=null;this.category=0;this.tabOffsets=[0,0,0,0];this.dragPath=null;this.dragCell=null;this.placed=null;this.pointers.clear();this.moveKeys.clear();if(this.materialInput)this.materialInput.blur();this.home();this.resetAttempt()
    this.ensureMissionSource()
    this.home()
    this.saveSlots?.markDirty()
  }
  nextLevel(){if(this.levelComplete){if(this.mode==='tutorial')this.startMission(0);else if(this.level<levels.length-1)this.startMission(this.level+1)}}
  mainCode(){return 'function main() {\n'+(this.result?(this.result.lines||[]).map(line=>'  '+line).join('\n')+'\n  return '+this.result.code+';':'  // 等待第一份成品')+'\n}'}

  beltInputs(b) {
    const inputs=[]
    dirs.forEach(([dx,dy],side)=>{
      const neighbor=this.buildingAt(b.x+dx,b.y+dy)
      if(neighbor && neighbor.dir===(side+2)%4 && side!==b.dir && (!isCollector(neighbor)||b.x+dx===neighbor.x&&b.y+dy===neighbor.y))inputs.push(side)
    })
    return inputs.length?inputs:[(b.dir+2)%4]
  }
  beltPoint(b,entry,t) {
    const [ix,iy]=dirs[entry], [ox,oy]=dirs[b.dir], u=1-t
    return {x:b.x*S+S/2+S/2*(u*u*ix+t*t*ox),y:b.y*S+S/2+S/2*(u*u*iy+t*t*oy),angle:Math.atan2(t*oy-u*iy,t*ox-u*ix)}
  }
  drawBelts() {
    const c=this.c, paths=[]
    for(const b of this.map.values())if(b.type==='belt')for(const entry of this.beltInputs(b))paths.push({b,entry})
    // Draw each layer for the entire network, so adjacent tiles share open ends.
    c.save();c.lineCap='butt';c.lineJoin='round'
    for(const [width,color] of [[42,'#8f9f82'],[39,'#b5c2a9']]){
      c.lineWidth=width;c.strokeStyle=color
      for(const {b,entry} of paths){const a=this.beltPoint(b,entry,0),z=this.beltPoint(b,entry,1);c.beginPath();c.moveTo(a.x,a.y);c.quadraticCurveTo(b.x*S+S/2,b.y*S+S/2,z.x,z.y);c.stroke()}
    }
    // A tile holds two repeats: straight connections keep the same animation phase.
    c.strokeStyle='#dfe8d5';c.lineWidth=2.5
    for(const {b,entry} of paths){
      for(let j=0;j<2;j++){
        const t=(j/2+this.time*BELT_SPEED)%1,p=this.beltPoint(b,entry,t)
        c.save();c.translate(p.x,p.y);c.rotate(p.angle);c.beginPath();c.moveTo(-5,-8);c.lineTo(1,0);c.lineTo(-5,8);c.stroke();c.restore()
      }
    }
    c.restore()
  }
  draw(){const c=this.c,w=this.w,h=this.h;c.setTransform(this.dpr,0,0,this.dpr,0,0);c.fillStyle='#edf0eb';c.fillRect(0,0,w,h);c.save();c.translate(w/2,h/2);c.scale(this.cam.z,this.cam.z);c.translate(-this.cam.x,-this.cam.y);const a=this.world(0,0),z=this.world(w,h);c.beginPath();c.strokeStyle='#dfe5da';c.lineWidth=1/this.cam.z
    for(let x=Math.ceil(a.x/S);x<=Math.floor(z.x/S);x++){c.moveTo(x*S,a.y);c.lineTo(x*S,z.y)}
    for(let y=Math.ceil(a.y/S);y<=Math.floor(z.y/S);y++){c.moveTo(a.x,y*S);c.lineTo(z.x,y*S)}
    c.stroke()

    this.drawBelts()
    // Ports sit underneath the cargo; machine housings sit above it.
    for(const b of this.map.values()){
      if(b.type==='belt')continue
      c.save();if(this.mapMove&&this.mapMove.active&&this.mapMove.building===b)c.globalAlpha=0.25;c.translate(b.x*S+28,b.y*S+28)
      this.drawDeviceBase(b)
      c.restore()
    }
    for(const i of this.items){const b=this.buildingAt(i.x,i.y);if(b){const entry=i.entry===undefined?(b.dir+2)%4:i.entry,p=this.beltPoint(isCollector(b)?{...b,x:i.x,y:i.y}:b,entry,i.p);this.drawCargo(i.value,p.x,p.y)}}
    for(const b of this.map.values()){
      if(b.type==='belt')continue
      c.save();if(this.mapMove&&this.mapMove.active&&this.mapMove.building===b)c.globalAlpha=0.25;c.translate(b.x*S+28,b.y*S+28)
      this.drawDeviceBody(b)
      c.restore()
    }
    if(this.returnFocusUntil>this.time)this.rect(-66,-71,188,188,'#ffad24',22)
    this.rect(-61,-61,178,182,'#cbd6c2',20);this.rect(-61,-66,178,178,'#fbfcf5',20,'#a6b698');this.text('成 品 出 货 站',28,-43,12,'#7b8c70','center',600)
    if(this.result){this.wrap(cargoText(this.result.value),-43,-9,140,14,3);this.text(cargoName(this.result.value),28,82,10,'#8ba078','center')}
    else{this.text('等待第一份成品',28,14,14,'#8b9b80','center');this.text('完成生产，从这里交付',28,43,10,'#9da993','center')}
    if(this.hover&&(this.mapMove?.active||this.tool!=='select')){
      const b=this.mapMove?.active?{...this.mapMove.building,...this.hover}:this.placementBuilding(this.hover),rows=machineRows(b),valid=this.fitsFootprint(b)&&this.canReplaceFootprint(b,this.mapMove?.building)
      c.globalAlpha=0.22;this.rect(this.hover.x*S+1,this.hover.y*S+1,54,rows*S-2,this.tool==='erase'||!valid?'#e0a695':toolColors(b.type).active,6,!valid?'#b9705a':'#74945f');c.globalAlpha=1
    }
    c.restore();this.buttons=[];this.drawMapControls();this.ui();this.drawCursorItem()
  }
  expandMax(building){return this.resizeMax(building,1)}
  shrinkMax(building){return this.resizeMax(building,-1)}
  resizeMax(building,delta){
    if(building.type!=='Math.max'||!isCollector(building)||this.map.get(key(building.x,building.y))!==building||![-1,1].includes(delta))return false
    const rows=machineRows(building),nextRows=rows+delta,target={x:building.x,y:building.y+rows}
    if(nextRows<2||nextRows>64)return false
    if(delta>0&&(!this.fitsFootprint({...building,rows:nextRows})||this.buildingAt(target.x,target.y))){
      this.saveMessage='下方需要空出一格';this.saveMessageUntil=performance.now()+2000;return false
    }
    this.recordUndo()
    if(delta<0)this.items=this.items.filter(item=>item.x!==building.x||item.y!==building.y+rows-1)
    building.rows=nextRows;building.variant='numbers-'+nextRows
    if(building.inputs)building.inputs=Array.from({length:nextRows},(_,index)=>building.inputs[index]||null)
    building.visualBatch=undefined;building.error=null
    return true
  }
  drawMapControls(){
    if(this.settlement||this.editor||this.overloadPicker||this.orderBook||this.help||this.tutorial)return
    for(const b of this.map.values()){
      if(b.type!=='Math.max'||!isCollector(b)||this.mapMove?.building===b)continue
      const z=this.cam.z,originX=(b.x*S+28-this.cam.x)*z+this.w/2,originY=(b.y*S+28-this.cam.y)*z+this.h/2
      for(const control of maxControls(b)){
        this.buttons.push({x:originX+control.x*z,y:originY+control.y*z,w:control.w*z,h:control.h*z,fn:()=>this.resizeMax(b,control.delta),tooltip:control.delta>0?'添加一个输入口':'移除最下面的输入口'})
      }
    }
  }
  drawCollectorSlots(b){
    const c=this.c,color=toolColors(b.type);c.save();if(b.dir===2)c.scale(-1,1)
    for(let row=0;row<machineRows(b);row++)this.rect(-29,row*S-8,14,16,b.inputs?.[row]?color.primary:color.ink,2)
    this.rect(18,-8,12,16,color.ink,2);c.restore()
  }
  drawCollectorBody(b){
    const c=this.c,color=toolColors(b.type),rows=machineRows(b),fill=b.error?'#f6ded7':color.card
    c.save();if(b.dir===2)c.scale(-1,1)
    c.beginPath();c.moveTo(0,-24)
    for(let row=0;row<rows;row++){
      const cy=row*S;c.quadraticCurveTo(23,cy-24,23,cy);c.quadraticCurveTo(23,cy+20,7,cy+24)
      if(row<rows-1)c.lineTo(7,cy+32)
    }
    c.quadraticCurveTo(0,(rows-1)*S+29,-7,(rows-1)*S+24)
    for(let row=rows-1;row>=0;row--){
      const cy=row*S;c.quadraticCurveTo(-23,cy+20,-23,cy);c.quadraticCurveTo(-23,cy-20,-7,cy-24)
      if(row>0)c.lineTo(-7,cy-32)
    }
    c.closePath();c.fillStyle=fill;c.fill();c.strokeStyle=b.error?'#ca7862':color.border;c.lineWidth=2;c.stroke()
    for(let row=1;row<rows;row++){
      this.rect(-10,row*S-10,20,20,color.active,7)
      c.fillStyle=color.ink;c.beginPath();c.moveTo(0,row*S-7);c.lineTo(-5,row*S+2);c.lineTo(5,row*S+2);c.closePath();c.fill()
      this.rect(-2,row*S+3,4,6,color.ink,1)
      this.rect(-2,row*S-30,4,8,color.border,2)
    }
    c.restore();drawMachineIcon(c,b.type,0,0,27,color.ink,fill)
  }
  drawDeviceBase(b,preview=false){
    const c=this.c,color=toolColors(b.type)
    if(b.type==='Math.max'){drawMaxSlots(this,b);return}
    if(isCollector(b)){this.drawCollectorSlots(b);return}
    if(b.type.startsWith('source.'))this.rect(-28,-28,56,56,color.active,6)
    const ports=b.type.startsWith('source.')?[b.dir]:preview?[(b.dir+2)%4,b.dir]:[...new Set([...this.beltInputs(b),b.dir])]
    for(const side of ports){c.save();c.rotate(side*Math.PI/2);this.rect(19,-14,10,28,color.border,3);this.rect(21,-11,8,22,color.ink,2);c.restore()}
  }
  drawDeviceBody(b){
    if(b.type==='Math.max'){drawMaxCabinet(this,b);return}
    if(isCollector(b)){this.drawCollectorBody(b);return}
    const color=toolColors(b.type),fill=b.error?'#f6ded7':color.card
    this.rect(-26,-23,52,49,color.border,7);this.rect(-25,-25,50,46,fill,6,b.error?'#ca7862':color.border)
    if(b.type==='source.number'||b.type==='source.string'){
      const text=b.args===undefined?'':String(b.args),layout=this.fittedMaterialText(text,40,36),c=this.c
      c.save();c.beginPath();c.rect(-20,-20,40,36);c.clip()
      const top=-2-(layout.lines.length-1)*layout.lineHeight/2
      layout.lines.forEach((line,index)=>this.text(line,0,top+index*layout.lineHeight,layout.font,b.error?'#b45d48':color.ink,'center'))
      c.restore()
    }else drawMachineIcon(this.c,b.type,0,-2,32,b.error?'#b45d48':color.ink,fill)
    if(b.missionSource){const c=this.c;c.save();c.strokeStyle=color.ink;c.lineWidth=1.5;c.beginPath();c.arc(18,-20,3,Math.PI,0);c.stroke();this.rect(14,-20,8,7,color.ink,2);c.restore()}
  }
  fittedMaterialText(text,width,height){
    if(!this.materialTextCache)this.materialTextCache=new Map()
    const key=width+','+height+':'+text,cached=this.materialTextCache.get(key)
    if(cached)return cached
    let font=18,lines=[]
    for(;font>=2;font--){
      this.c.font=font+'px "Segoe UI","Microsoft YaHei",sans-serif'
      lines=[];let line=''
      for(const ch of text){
        if(ch==='\n'){lines.push(line);line='';continue}
        if(line&&this.c.measureText(line+ch).width>width){lines.push(line);line=''}
        line+=ch
      }
      lines.push(line)
      if(lines.length*font*1.15<=height||font===2)break
    }
    const result={font,lines,lineHeight:font*1.15}
    if(this.materialTextCache.size>=128)this.materialTextCache.delete(this.materialTextCache.keys().next().value)
    this.materialTextCache.set(key,result);return result
  }
  drawCursorItem(){
    const p=this.pointerPosition,moving=this.mapMove&&this.mapMove.active?this.mapMove.building:null,tool=moving?moving.type:this.tool
    if(!p||this.settlement||this.orderBook||tool==='select'||this.editor||this.overloadPicker||this.help||this.tabDrag||this.tutorial&&this.tutorial.step!==3.5&&this.tutorial.step!==6)return
    // Menu interaction should not carry a ghost over the menu or the tooltip.
    if(this.buttons.some(b=>p.x>=b.x&&p.x<=b.x+b.w&&p.y>=b.y&&p.y<=b.y+b.h)||this.tabRegions.some(r=>p.x>=r.x&&p.x<=r.x+r.w&&p.y>=r.y&&p.y<=r.y+r.h))return
    const c=this.c;c.save();c.translate(p.x+(moving?0:18),p.y+(moving?-(this.mapMove.from.y-moving.y)*S*this.cam.z:18));c.scale(this.cam.z,this.cam.z);c.globalAlpha=0.55
    if(tool==='belt'){
      c.rotate((moving?moving.dir:this.dir)*Math.PI/2)
      this.rect(-28,-21,56,42,'#8f9f82');this.rect(-28,-19.5,56,39,'#b5c2a9')
      c.beginPath();c.rect(-28,-19,56,38);c.clip();c.strokeStyle='#dfe8d5';c.lineWidth=2.5
      for(let i=-1;i<3;i++){const x=i*28+(this.time*BELT_SPEED*56)%28;c.beginPath();c.moveTo(x-5,-8);c.lineTo(x+1,0);c.lineTo(x-5,8);c.stroke()}
    }else if(tool==='erase'){
      this.rect(-24,-24,48,48,'#e0a695',7,'#b9705a');this.text('×',0,0,32,'#a3523e','center',700)
    }else if(methods[tool]){
      const b=moving||this.placementBuilding({x:0,y:0});this.drawDeviceBase(b,true);this.drawDeviceBody(b)
    }
    c.restore()
  }
  drawTabs(index,x,y,w,h,tabs){
    const gap=5,widths=tabs.map(t=>index===3?40:index===2?60:Math.max(94,t.label.length*14+24)),total=widths.reduce((a,b)=>a+b+gap,0)-gap,max=Math.max(0,total-w)
    const offset=this.tabOffsets[index]=Math.max(0,Math.min(max,this.tabOffsets[index]||0))
    this.tabRegions.push({index,x,y,w,h,max})
    const c=this.c;c.save();c.beginPath();c.rect(x,y,w,h);c.clip()
    let left=x-offset
    tabs.forEach((tab,i)=>{
      const width=widths[i]
      if(left+width>x&&left<x+w){
        c.save();if(tab.disabled||tab.dimmed)c.globalAlpha*=0.35
        const color=tab.color,ink=index===0?(tab.active?'#ffffff':'#dedede'):color?color.ink:tab.active?'#486238':'#7c8d6b'
        const fill=index===0?(tab.active?'#111111':'#292929'):color?(tab.active?color.active:index===1?color.tab:color.card):tab.active?['#edf2e5','#fbfcf7','#e5eedb'][index]:'#f7f9f2'
        // Folder tabs only round the top corners; the bottom sits flush.
        const bottom=y+h-5,r=8
        if(index>=2)this.rect(left,y,width,h-5,fill,r)
        else{c.beginPath();c.moveTo(left,bottom);c.lineTo(left,y+r);c.quadraticCurveTo(left,y,left+r,y);c.lineTo(left+width-r,y);c.quadraticCurveTo(left+width,y,left+width,y+r);c.lineTo(left+width,bottom);c.closePath();c.fillStyle=fill;c.fill()}
        c.strokeStyle=tab.active?'#ffad24':index===0?'#464646':color?color.border:'#d6dfce';c.lineWidth=tab.active?2:1;c.stroke();c.lineWidth=1
        if(tab.active&&index<2)this.rect(left+1,y+h-14,width-2,14,fill)
        if(tab.icon&&index>=2){drawMachineIcon(c,tab.icon,left+width/2,index===2?y+23:y+(h-5)/2,index===2?30:22,index===0?ink:color?color.ink:tab.active?'#567440':'#82956f',fill);if(index===2)this.fitText(tab.label,left+width/2,y+49,width-8,10,ink,'center')}
        else this.text(tab.label,left+width/2,y+(h-5)/2,13,ink,'center',tab.active?600:400)
        this.buttons.push({x:left,y,w:width,h:h-5,fn:tab.disabled?()=>{}:tab.fn,disabled:!!tab.disabled,tooltip:tab.tooltip})
        const hit=this.buttons[this.buttons.length-1],right=Math.min(x+w,left+width);hit.x=Math.max(x,left);hit.w=right-hit.x;hit.tab=index;c.restore()
      }
      left+=width+gap
    })
    c.restore()
    if(max>0){const thumb=Math.max(25,w*w/total);this.rect(x,y+h-2,w,2,'#e6ecdf',1);this.rect(x+(w-thumb)*offset/max,y+h-2,thumb,2,'#a7bd94',1)}
  }
  ui(){
    this.saveSlots?.tick()
    const w=this.w,h=this.h,p=this.small?10:24
    const visibleWorkshops=this.visibleWorkshops()
    if(!visibleWorkshops.some(entry=>entry.index===this.workshop)){this.workshop=visibleWorkshops[0]?.index||0;this.category=0;this.tabOffsets=[0,0,0,0]}
    this.drawBrand(p)
    const barW=w,x=0,y=h-147
    this.rect(x,y,barW,137,'#fcfdf8',6,'#d1ddc6')
    // Nested folder surfaces: workshop contains a room, which contains equipment.
    this.rect(x+2,y+32,barW-4,103,'#edf2e5',4,'#bfceb0')
    if(menuConfig.workshops[this.workshop].children.length)this.rect(x+4,y+64,barW-8,69,'#fbfcf7',2,'#c8d5bc')
    this.button(x,y-46,40,40,'',()=>this.toggleTool('belt'),this.tool==='belt');drawMachineIcon(this.c,'belt',x+20,y-26,25);this.buttons[this.buttons.length-1].tooltip='传送带';this.buttons[this.buttons.length-1].tutorialId='belt'
    this.tabRegions=[]
    const materials=menuConfig.workshops.flatMap(workshop=>workshop.children).flatMap(room=>room.methods).filter(method=>method.id.startsWith('source.'))
    const materialWidth=Math.min(Math.max(0,materials.length*45-5),Math.max(0,barW-108)),deleteX=x+46+materialWidth+16
    this.button(deleteX,y-46,40,40,'',()=>this.toggleTool('erase'),this.tool==='erase');drawMachineIcon(this.c,'erase',deleteX+20,y-26,25);this.buttons[this.buttons.length-1].tooltip='删除'
    this.drawTabs(3,x+46,y-46,materialWidth,45,materials.map(method=>({label:appearance(method.id).name,icon:method.id,color:toolColors(method.id),tooltip:this.apiName(methods[method.id]),active:this.tool===method.id,fn:()=>this.toggleTool(method.id)})))
    const workshops=menuConfig.workshops.map(w=>w.name)
    const workshop=menuConfig.workshops[this.workshop],rooms=workshop.children,roomTabs=this.roomTabs(workshop)
    if(!roomTabs.some(tab=>tab.index===this.category&&!tab.disabled))this.category=roomTabs.find(tab=>!tab.disabled)?.index??-1
    this.drawTabs(0,x+2,y+2,barW-4,34,visibleWorkshops.map(({workshop:entry,index:i})=>({label:entry.name,tooltip:entry.original,active:this.workshop===i,fn:()=>{if(this.workshop!==i){this.workshop=i;this.tabOffsets[1]=0;this.tabOffsets[2]=0;this.category=0}this.tool='select'}})))
    if(rooms.length){
      this.drawTabs(1,x+4,y+34,barW-8,34,roomTabs.map(({room,index:i,dimmed})=>({label:room.name,tooltip:room.original,color:roomColors(room.id),dimmed,active:this.category===i,fn:()=>{if(this.category!==i){this.category=i;this.tabOffsets[2]=0}else this.tool='select'}})))
      if(this.category>=0)this.drawTabs(2,x+6,y+66,barW-12,65,rooms[this.category].methods.map(m=>({label:appearance(m.id).name,color:roomColors(rooms[this.category].id),icon:m.id,tooltip:appearance(m.id).name+' · '+this.apiName(methods[m.id]),active:this.tool===m.id,fn:()=>this.toggleTool(m.id)})))
    }else{
      this.text(workshops[this.workshop]+'正在筹建',x+18,y+65,13,'#89967e')
      this.fitText(menuConfig.workshops[this.workshop].description,x+18,y+103,barW-36,11,'#9aa58f')
    }
    this.button(w-p-40,y-190,40,36,'+',()=>this.zoom(1.2));this.button(w-p-40,y-147,40,36,'−',()=>this.zoom(0.8));this.button(w-p-40,y-104,40,36,'',()=>this.home())
    this.buttons[this.buttons.length-1].tooltip='回到中心 · H';drawMenuIcon(this.c,'home',w-p-20,y-86,24)
    if(this.saveMessage&&performance.now()<this.saveMessageUntil)this.fitText(this.saveMessage,w/2,y-82,w-100,11,'#7e926c','center')
    if((this.liveOpen||this.statsOpen)&&y>p+230){
      const liveW=this.small?(w-3*p)/2:280,liveX=w-p-liveW,liveY=p+130
      const liveH=Math.min(232,Math.max(100,y-liveY-30))
      this.rect(liveX,liveY,liveW,liveH,'#fbfcf7',12,'#d8e1d0')
      const c=this.c;c.save();c.beginPath();c.rect(liveX+8,liveY+8,liveW-16,liveH-16);c.clip()
      this.fitText(this.liveOpen?'LIVE JAVASCRIPT':'生产概况',liveX+12,liveY+23,liveW-24,11,'#819173')
      if(this.liveOpen)this.wrap(this.mainCode(),liveX+12,liveY+51,liveW-24,12,Math.max(1,Math.floor((liveH-112)/19)))
      else{this.text('设备数量：'+this.map.size,liveX+12,liveY+55,12);this.text('运输物料：'+this.items.length,liveX+12,liveY+82,12);this.text('完成交付：'+this.total,liveX+12,liveY+109,12)}
      this.text('最近结果',liveX+12,liveY+liveH-51,11)
      this.fitText(this.history[0]||'等待第一批数据…',liveX+12,liveY+liveH-27,liveW-24,12);c.restore()
      this.buttons.push({x:liveX,y:liveY,w:liveW,h:liveH,fn:()=>{}})
    }
    if(this.missionOpen!==false&&(!this.small||!this.liveOpen&&!this.statsOpen)){
    this.drawMissionPanel(p)
    }
    this.drawShortcuts(p,y-40)
    const error=[...this.map.values()].find(b=>b.error)
    if(error){this.rect(p,this.small?p+69:p+320,Math.min(w-2*p-52,400),48,'#f9e5df',9);this.fitText(appearance(error.type).name+'：'+error.error,p+12,this.small?p+93:p+344,Math.min(w-2*p-76,376),11,'#ae6651')}
    this.drawTopMenu(p)
    if(this.orderBook)this.drawOrderBook()
    if(this.help)this.drawHelp()
    if(this.editor)this.drawEditor()
    if(this.overloadPicker)this.drawOverloadPicker()
    this.drawMenuTooltip()
    if(this.tutorial&&!this.settlement)this.tutorial.draw()
    if(this.settlement)this.drawSettlement()
    if(this.settlement&&['saves','cloud'].includes(this.help))this.drawHelp()
  }
  materialLayout(value){
    const text=cargoText(value),textual=typeof value==='number'||typeof value==='string'
    if(!textual)return {size:32,text,lines:[],font:13}
    const c=this.c,font=13,lineHeight=16
    c.font=font+'px "Segoe UI","Microsoft YaHei",sans-serif'
    const split=width=>{
      const lines=[];let line=''
      for(const ch of text){if(ch==='\n'){lines.push(line);line='';continue}if(line&&c.measureText(line+ch).width>width){lines.push(line);line=''}line+=ch}
      lines.push(line);return lines
    }
    let size=32,lines=split(size-10)
    while(lines.length*lineHeight>size-10&&size<Math.min(240,this.w-106)){size+=16;lines=split(size-10)}
    return {size,text,lines,font,lineHeight}
  }
  drawMissionPanel(p){
    const mission=this.currentMission(),w=Math.min(400,this.w-32),x=(this.w-w)/2,y=p+(this.small?116:72)
    const input=mission.input?mission.input.value:'ok',targetLayout=this.materialLayout(mission.target),inputLayout=this.materialLayout(input)
    const inputY=46,targetY=inputY+inputLayout.size+14,hintY=targetY+targetLayout.size+22,toolsY=hintY+23,available=w-32
    const groups=[],rooms=menuConfig.workshops.flatMap(workshop=>workshop.children)
    for(const id of mission.required||[]){
      const room=rooms.find(room=>room.methods.some(method=>method.id===id)),previous=groups[groups.length-1]
      if(previous&&previous.room===room)previous.ids.push(id)
      else groups.push({room,ids:[id]})
    }
    let groupX=0,groupY=0,rowHeight=0
    for(const group of groups){
      const columns=Math.max(1,Math.min(group.ids.length,Math.floor((available+5)/65))),width=columns*65-5,height=24+Math.ceil(group.ids.length/columns)*65-5
      if(groupX&&groupX+width>available){groupX=0;groupY+=rowHeight+12;rowHeight=0}
      group.left=groupX;group.top=groupY;group.width=width;group.columns=columns
      groupX+=width+14;rowHeight=Math.max(rowHeight,height)
    }
    const toolsH=groups.length?groupY+rowHeight:0,footer=this.levelComplete?44:0,h=toolsY+toolsH+footer+14
    this.rect(x,y,w,h,'#fbfcf7ed',12,'#d8e1d0')
    this.fitText((this.mode==='tutorial'?'入门练习':'订单 '+(this.level+1)+' / '+levels.length)+' · '+mission.name,x+16,y+23,w-32,14,'#5e774c')
    this.drawMissionMaterial('原料',input,mission.input?mission.input.type:'source.string',x+16,y+inputY,inputLayout)
    this.drawMissionMaterial('目标',mission.target,null,x+16,y+targetY,targetLayout)
    this.fitText(this.levelComplete?'订单完成！':this.delivery&&!this.delivery.ok?this.delivery.reason:mission.hint,x+16,y+hintY,w-32,12,this.levelComplete?'#c78b22':'#8c9c7c')
    for(const group of groups){
      const gx=x+16+group.left,gy=y+toolsY+group.top
      this.fitText(group.room?group.room.name:'所需道具',gx,gy+10,Math.max(60,group.width),12,'#6c7b62')
      group.ids.forEach((id,index)=>{
        const color=toolColors(id),cx=gx+index%group.columns*65,cy=gy+24+Math.floor(index/group.columns)*65
        this.rect(cx,cy,60,60,color.card,8,color.border)
        drawMachineIcon(this.c,id,cx+30,cy+23,30,color.ink,color.card)
        this.fitText(appearance(id).name,cx+30,cy+49,52,10,color.ink,'center')
        this.buttons.push({x:cx,y:cy,w:60,h:60,fn:()=>{},tooltip:appearance(id).name+' · '+this.apiName(methods[id])})
      })
    }
    this.buttons.push({x,y,w,h,fn:()=>{}})
    if(this.levelComplete&&(this.mode==='tutorial'||this.level<levels.length-1))this.button(x+w-106,y+h-48,90,34,'下一关 →',()=>this.nextLevel(),true)
  }
  drawMissionMaterial(label,value,type,x,y,layout){
    const material=type||(typeof value==='number'?'source.number':typeof value==='string'?'source.string':typeof value==='boolean'?'Boolean':Array.isArray(value)?'source.array':value instanceof Date?'source.date':'source.object')
    const color=toolColors(material),icon=typeof value==='boolean'?(value?'value.true':'value.false'):material
    const {size,text,lines,font,lineHeight}=layout,left=x+42
    this.text(label,x,y+size/2,13,'#6c7b62')
    this.rect(left,y,size,size,color.card,7,color.border)
    this.c.save();this.c.beginPath();this.c.rect(left+3,y+3,size-6,size-6);this.c.clip()
    if(lines.length){const top=y+size/2-(lines.length-1)*lineHeight/2;lines.forEach((line,index)=>this.text(line,left+size/2,top+index*lineHeight,font,color.ink,'center'))}
    else drawMachineIcon(this.c,icon,left+size/2,y+size/2,25,color.ink,color.card)
    this.c.restore()
    this.buttons.push({x:left,y,w:size,h:size,fn:()=>{},tooltip:label+' · '+text})
  }
  drawOverloadPicker(){
    const picker=this.overloadPicker,w=Math.min(620,this.w-24),h=Math.min(410,this.h-24),x=(this.w-w)/2,y=(this.h-h)/2
    const columns=this.w<480?1:2,rows=Math.max(1,Math.floor((h-130)/64)),perPage=columns*rows,pages=Math.ceil(picker.forms.length/perPage)
    picker.page=Math.min(picker.page,pages-1)
    this.c.fillStyle='#24352b88';this.c.fillRect(0,0,this.w,this.h);this.rect(x,y,w,h,'#fcfdf8',16,'#d8e1d0')
    this.text(appearance(picker.type).name+' · 选择进料规格',x+20,y+28,18,'#405a37','left',600)
    this.buttons=[];this.tabRegions=[]
    const gap=10,cardW=(w-40-gap*(columns-1))/columns
    picker.forms.slice(picker.page*perPage,(picker.page+1)*perPage).forEach((form,index)=>{
      const left=x+20+index%columns*(cardW+gap),top=y+60+Math.floor(index/columns)*64,color=toolColors(picker.type)
      this.rect(left,top,cardW,54,color.card,9,color.border)
      const count=Math.min(form.rows,4),miniH=Math.min(30,form.rows*8)
      for(let i=0;i<count;i++)this.rect(left+12,top+27-miniH/2+i*miniH/count,15,miniH/count-1,color.ink,2)
      this.fitText(form.name,left+38,top+18,cardW-46,13,color.ink)
      this.fitText(form.detail,left+38,top+38,cardW-46,10,color.ink)
      this.buttons.push({x:left,y:top,w:cardW,h:54,fn:()=>{this.toolSetup={type:picker.type,variant:form.id,rows:form.rows,args:JSON.parse(JSON.stringify(form.args))};this.sample=null;this.tool=picker.type;if(form.collector&&![0,2].includes(this.dir))this.dir=0;this.overloadPicker=null},tooltip:this.apiName(methods[picker.type])})
    })
    this.button(x+20,y+h-50,78,32,'取消',()=>{this.overloadPicker=null})
    if(pages>1){
      this.button(x+w-190,y+h-50,42,32,'‹',()=>{picker.page=Math.max(0,picker.page-1)})
      this.text((picker.page+1)+' / '+pages,x+w-112,y+h-34,12,'#7d8a73','center')
      this.button(x+w-62,y+h-50,42,32,'›',()=>{picker.page=Math.min(pages-1,picker.page+1)})
    }
  }
  drawOrderBook(){
    const w=Math.min(620,this.w-24),h=Math.min(548,this.h-24),x=(this.w-w)/2,y=(this.h-h)/2
    this.c.fillStyle='#24352b88';this.c.fillRect(0,0,this.w,this.h)
    this.buttons.push({x:0,y:0,w:this.w,h:this.h,fn:()=>{}});this.tabRegions=[]
    this.rect(x,y,w,h,'#fcfdf8',18,'#d8e1d0');this.text('雾港工区 · 订单簿',x+20,y+29,19,'#48613c','left',700)
    this.button(x+w-60,y+12,44,30,'×',()=>{this.orderBook=false})
    const page=this.orderPage||0,rowH=Math.min(63,(h-150)/6)
    levels.slice(page*6,page*6+6).forEach((level,i)=>{
      const index=page*6+i,top=y+58+i*rowH,done=this.completed.has(level.id),locked=!this.isMissionUnlocked(index)
      if(locked)this.c.globalAlpha=0.4
      this.button(x+16,top,w-32,rowH-5,(done?'✓ ':'')+(index+1)+'. '+level.name,()=>this.startMission(index),this.mode==='campaign'&&index===this.level)
      this.c.globalAlpha=1
      if(locked){const button=this.buttons[this.buttons.length-1];button.fn=()=>{};button.disabled=true;button.tooltip='请先完成前面的订单';this.text('未解锁',x+w-35,top+(rowH-5)/2,12,'#99a18e','right')}
    })
    const bottom=y+h-76
    this.button(x+16,bottom,90,30,'← 上页',()=>{this.orderPage=Math.max(0,page-1)})
    this.text((page+1)+' / '+Math.ceil(levels.length/6),x+w/2,bottom+15,12,'#718163','center')
    this.button(x+w-106,bottom,90,30,'下页 →',()=>{this.orderPage=Math.min(Math.ceil(levels.length/6)-1,page+1)})
    this.button(x+16,y+h-39,w-32,28,'入门练习 · 送出一声问候',()=>{this.startMission(0,'tutorial');this.tutorial=new Tutorial(this)})
  }
  drawTopMenu(p){
    const {size,gap,x,y}=this.headerLayout(p)
    const entries=[
      ['order','订单',()=>{this.missionOpen=!this.missionOpen;if(this.missionOpen&&this.w<this.h){this.liveOpen=false;this.statsOpen=false}}],
      ['js','JS',()=>{this.liveOpen=!this.liveOpen;this.statsOpen=false}],
      ['level','订单簿',()=>{this.orderBook=!this.orderBook;this.orderPage=Math.floor(this.level/6)}],
      ['stats','天体榜',()=>this.cloud?.openBoard()],
      ['save','保存地图 · Ctrl+S',()=>this.save()],
      ['settings','设置',()=>{this.settingsOpen=!this.settingsOpen}]
    ]
    entries.forEach(([id,label,fn],i)=>{
      const left=x+i*(size+gap),active=id==='order'&&this.missionOpen||id==='js'&&this.liveOpen||id==='stats'&&this.help==='cloud'&&this.cloud?.mode==='board'||id==='settings'&&this.settingsOpen
      if(active)this.rect(left,y,size,size,'#e3e9dc',8)
      drawMenuIcon(this.c,id,left+size/2,y+size/2,size-8,this.level+1)
      this.buttons.push({x:left,y,w:size,h:size,fn,tooltip:label})
    })
    if(this.settingsOpen){
      const menuX=this.w-p-190,menuY=y+size+8
      this.rect(menuX,menuY,190,204,'#fbfcf7',10,'#d8e1d0')
      this.buttons.push({x:menuX,y:menuY,w:190,h:204,fn:()=>{}})
      const options=[['加载地图 · L',()=>this.load()],['保存地图 · Ctrl+S',()=>this.save()],[this.cloud?.user?'账号资料':'登录',()=>this.cloud?.openAccount()],[this.paused?'继续生产':'暂停生产',()=>{this.paused=!this.paused}],['操作说明',()=>{this.help=true}]]
      options.forEach(([label,fn],i)=>this.button(menuX+8,menuY+8+i*38,174,32,label,()=>{this.settingsOpen=false;fn()}))
    }
  }
  headerLayout(p){
    const size=this.w<760?28:36,gap=this.w<760?4:6
    return {size,gap,x:this.w-p-6*size-5*gap,y:p}
  }
  drawBrand(p){
    const c=this.c,{size,x}=this.headerLayout(p),diameter=size,available=x-p-8,font=Math.min(25,Math.max(10,(available-diameter-6)/5)),cy=p+size/2
    c.save();c.beginPath();c.arc(p+diameter/2,cy,diameter/2,0,Math.PI*2);c.fillStyle='#ffffff';c.fill();c.clip()
    if(this.logoArt?.complete&&this.logoArt.naturalWidth)c.drawImage(this.logoArt,p+2,p+2,diameter-4,diameter-4)
    c.restore();c.save();c.beginPath();c.arc(p+diameter/2,cy,diameter/2-1,0,Math.PI*2);c.strokeStyle='#ffffff';c.lineWidth=2;c.stroke()
    const colors=['#ff332f','#ff9400','#ffc900','#12bd61','#167dff'],shadows=['#a51e21','#ad5a00','#ac8000','#08723c','#174ca5']
    c.font='900 '+font+'px "Microsoft YaHei",sans-serif';c.textAlign='left';c.textBaseline='middle';c.lineJoin='round';c.lineWidth=Math.max(1,font*.08)
    Array.from('歪脖鸡皮油').forEach((letter,index)=>{const left=p+diameter+6+index*font;c.strokeStyle='#ffffff';c.strokeText(letter,left,cy);c.fillStyle=shadows[index];for(let depth=3;depth>0;depth--)c.fillText(letter,left,cy+depth);c.fillStyle=colors[index];c.fillText(letter,left,cy)})
    c.restore()
  }
  toggleShortcuts(){
    if(this.w<this.h){this.help=this.help==='shortcuts'?false:'shortcuts';return}
    this.shortcutsOpen=!this.shortcutsOpen
  }
  moveCamera(dt){
    if(this.settlement||this.editor||this.overloadPicker||this.help||this.tutorial||this.orderBook)return
    const keys=this.moveKeys,dx=Number(keys.has('d'))-Number(keys.has('a')),dy=Number(keys.has('s'))-Number(keys.has('w')),length=Math.hypot(dx,dy)||1
    this.cam.x+=dx/length*420*dt/this.cam.z;this.cam.y+=dy/length*420*dt/this.cam.z
  }
  drawShortcuts(p,menuY,dialog=null){
    const x=dialog?dialog.x:p,y=dialog?dialog.y:p+(this.small?64:80),compact=this.small||!!dialog,c=this.c,size=compact?11:16,row=dialog?dialog.row:compact?27:32
    if(!dialog&&(!this.shortcutsOpen||this.w<this.h)){this.text('F1  操作提示',x,y,11,'#7e8d76');this.buttons.push({x,y:y-12,w:100,h:26,fn:()=>this.toggleShortcuts()});return}
    const keycap=(left,top,label)=>{
      const width=Math.max(24,label.length*(compact?7:9)+12),height=compact?21:24
      this.rect(left,top+2,width,height,'#c7cec6',4);this.rect(left,top,width,height,'#ffffff',4)
      this.text(label,left+width/2,top+height/2,compact?11:15,'#80838b','center',700);return width
    }
    const mouse=(left,top,button)=>{
      this.rect(left,top+2,23,25,'#c7cec6',8);this.rect(left,top,23,25,'#ffffff',8)
      c.save();c.beginPath();c.rect(left+3,top+3,17,10);c.clip()
      this.rect(left+3,top+2,17,20,'#9a9da6',6)
      this.rect(left+(button==='right'?12:3),top+2,8,13,'#dc51a0',3)
      c.restore();this.rect(left+10.5,top+2,2,11,'#ffffff');this.rect(left+3,top+13,17,2,'#ffffff');return 23
    }
    const label=(t,left,top)=>this.text(t,left,top+12,size,'#424a44')
    const rows=[]
    rows.push(top=>{
      let left=x
      if(this.tool==='select'){left+=mouse(left,top,'left')+8;label('/',left,top);left+=17}
      for(const letter of ['W','A','S','D'])left+=keycap(left,top,letter)+4
      label('移动地图',left+7,top)
    })
    rows.push(top=>{mouse(x,top,'right');label('销毁',x+35,top)})
    rows.push(top=>{keycap(x,top,'Q');label('吸取器',x+35,top)})
    rows.push(top=>{const width=keycap(x,top,'Ctrl+C');label('撤回',x+width+12,top)})
    rows.push(top=>{const width=keycap(x,top,'Ctrl+Y');label('重做',x+width+12,top)})
    if(this.tool==='select')rows.push(top=>{mouse(x,top,'left');label('拖动设备',x+35,top)})
    if(this.tool!=='select'&&this.tool!=='erase'){
      rows.push(top=>{mouse(x,top,'left');label(this.tool==='belt'?'拖动连续铺带':'放置设备',x+35,top)})
      rows.push(top=>{keycap(x,top,'R');label('旋转方向',x+35,top)})
    }
    rows.push(top=>{const width=keycap(x,top,'Space');label(this.paused?'继续生产':'暂停生产',x+width+12,top)})
    rows.push(top=>{const width=keycap(x,top,'Ctrl+S');label('保存工厂',x+width+12,top)})
    rows.push(top=>{keycap(x,top,'L');label('加载地图',x+35,top)})
    rows.push(top=>{keycap(x,top,'H');label('回到中心',x+35,top)})
    rows.push(top=>{const width=keycap(x,top,'Esc');label('返回漫游',x+width+12,top)})
    const count=Math.min(rows.length,Math.max(0,Math.floor((menuY-y-18)/row)))
    rows.slice(0,count).forEach((draw,i)=>draw(y+i*row))
    if(!dialog)this.text('F1 收起提示',x,y+count*row+8,10,'#8a9780')
  }
  apiName(method){
    const id=method.id
    if(id==='Array.index')return 'Array[index]'
    if(id==='Object.get')return 'Object[key]'
    if(id==='operator.multiply')return '*'
    if(id==='Date.getUTCFullYear')return 'Date.prototype.getUTCFullYear()'
    if(id.startsWith('keyword.'))return id.slice(8)
    if(id.startsWith('source.'))return {'source.number':'Number 字面量','source.string':'String 字面量','source.array':'Array 字面量','source.object':'Object 字面量','source.date':'new Date()'}[id]
    if(id==='Object.fromEntries'||id.startsWith('Object.')||id.startsWith('Math.')||id.startsWith('JSON.')||id.startsWith('Number.')&&id!=='Number.toFixed')return id+'()'
    const name=id.replace(/^(Array|String|Number)\./,'$1.prototype.')
    return name+(method.property?'':'()')
  }
  drawMenuTooltip(){
    const p=this.menuPointer
    if(!p||this.settlement||this.editor||this.help||this.tabDrag||this.pointers.size)return
    const hit=this.buttons.find(b=>b.tooltip&&p.x>=b.x&&p.x<=b.x+b.w&&p.y>=b.y&&p.y<=b.y+b.h)
    if(!hit)return
    const c=this.c;c.save();c.font='12px "Segoe UI","Microsoft YaHei",sans-serif'
    const width=Math.min(this.w-16,c.measureText(hit.tooltip).width+24),height=32
    const x=Math.max(8,Math.min(this.w-width-8,hit.x+hit.w/2-width/2)),y=Math.max(8,hit.y-height-8)
    c.shadowColor='#22311e22';c.shadowBlur=10;c.shadowOffsetY=3
    this.rect(x,y,width,height,'#364b2f',7)
    c.shadowBlur=0;c.shadowOffsetY=0
    this.fitText(hit.tooltip,x+width/2,y+height/2,width-20,12,'#f5f9ed','center');c.restore()
  }
  drawHelp(){
    if(this.help==='saves'){this.saveSlots.draw();return}
    if(this.help==='cloud'){this.cloud.draw();return}
    if(this.help==='shortcuts'){
      const w=Math.min(350,this.w-24),h=Math.min(535,this.h-24),x=(this.w-w)/2,y=(this.h-h)/2
      this.c.fillStyle='#293e3088';this.c.fillRect(0,0,this.w,this.h);this.rect(x,y,w,h,'#fbfcf7',16)
      this.text('操作提示',x+20,y+27,18,'#4b633b','left',700);this.buttons=[];this.tabRegions=[]
      this.drawShortcuts(0,y+h-62,{x:x+20,y:y+58,row:Math.min(30,(h-120)/13)})
      this.button(x+w-56,y+12,36,30,'×',()=>{this.help=false});return
    }
    const w=Math.min(500,this.w-24),x=(this.w-w)/2,h=Math.min(370,this.h-24),y=(this.h-h)/2;this.c.fillStyle='#293e3066';this.c.fillRect(0,0,this.w,this.h);this.rect(x,y,w,h,'#fbfcf7',16)
    this.text('让每一份来料，各得其所。',x+20,y+30,18,'#4b633b','left',700)
    this.wrap('底部依次选择工坊、车间和设备，每层都可以左右拖动。在传送带右侧选择数字、文字、时间、批量或映射原材料，再用传送带连接加工工位。文字车间可以剪信、装订、誊抄和涂改。货箱车间负责逐件加工和筛选。漫游模式点击工位可调整配方：文字直接填写，货箱每行放一件货物。Tab 切换填写处，Shift+Enter 换行。1–4 切换工具，R 旋转，空格暂停。只有传送带可连续拖动铺设。默认地图为空，点击保存或 Ctrl+S 保存；点击加载或 L 读取存档。',x+20,y+68,w-40,13,9)
    this.buttons=[];this.button(x+20,y+h-49,w-40,32,'开工吧',()=>{this.help=false})
  }
  drawCargo(value,x,y){
    const c=this.c;c.save();c.translate(x,y);c.scale(1.35,1.35);x=0;y=0
    if(value instanceof Date){
      this.rect(x-11,y-10,22,20,'#fff8df',3,'#a28f6d');this.rect(x-11,y-10,22,6,'#c18469',2);this.text(String(value.getDate()),x,y+3,10,'#856c41','center',700)
    }else if(typeof value==='string'){
      this.rect(x-12,y-9,24,18,'#fff7df',2,'#b29b72');const c=this.c;c.strokeStyle='#b29b72';c.lineWidth=1;c.beginPath();c.moveTo(x-11,y-8);c.lineTo(x,y);c.lineTo(x+11,y-8);c.stroke();this.rect(x-2,y-1,4,4,'#bc7860',2)
    }else if(Array.isArray(value)||value&&typeof value==='object'){
      this.rect(x-11,y-10,22,20,'#d7bd86',2,'#a48b5b');this.rect(x-2,y-10,4,20,'#efdfb8');this.text(Array.isArray(value)?String(value.length):'单',x,y+1,8,'#856c41','center')
    }else{this.rect(x-10,y-9,20,18,typeof value==='number'?'#a9c6d9':'#b5caa4',4);this.fitText(cargoText(value),x,y,18,9,'#466147','center')}
    c.restore()
  }
  setMaterialText(text){
    if(!this.editor)return
    this.editor.text=text;this.editor.replace=false;this.editor.error=''
    if(this.materialInput){this.materialInput.value=text;this.materialInput.focus({preventScroll:true});this.materialInput.setSelectionRange(text.length,text.length)}
  }
  positionNumberCaret(pointerX,extend){
    if(!this.materialInput||!this.editor)return
    const input=this.materialInput,text=this.editor.text,field=this.numericField,c=this.c
    c.font='22px "Segoe UI","Microsoft YaHei",sans-serif'
    const offset=pointerX-field.x-14+(this.editor.numberScroll||0)
    let position=0
    for(let i=0;i<text.length;i++){const midpoint=(c.measureText(text.slice(0,i)).width+c.measureText(text.slice(0,i+1)).width)/2;if(offset<midpoint)break;position=i+1}
    if(!extend)this.numericAnchor=position
    const anchor=this.numericAnchor===undefined?position:this.numericAnchor
    input.focus({preventScroll:true});input.setSelectionRange(Math.min(anchor,position),Math.max(anchor,position),position<anchor?'backward':'forward')
    this.editor.caretTime=performance.now()
  }
  drawNumberEditor(){
    const ed=this.editor,c=this.c,w=Math.min(460,this.w-28),h=Math.min(292,this.h-24),x=(this.w-w)/2,y=(this.h-h)/2
    this.editorBounds={x,y,w,h};c.save();c.fillStyle='#17203388';c.fillRect(0,0,this.w,this.h)
    c.shadowColor='#16203326';c.shadowBlur=32;c.shadowOffsetY=12;this.rect(x,y,w,h,'#ffffff',14);c.shadowBlur=0;c.shadowOffsetY=0
    this.text('数字物料',x+24,y+32,20,'#25334a','left',600)
    this.text('供应数量',x+24,y+96,12,'#43516a','left',600)
    const f=this.numericField={x:x+24,y:y+112,w:w-48,h:54}
    this.rect(f.x,f.y,f.w,f.h,'#ffffff',7,ed.error?'#d66060':'#4c97ff')
    const input=this.materialInput,start=input?input.selectionStart:0,end=input?input.selectionEnd:0,caret=input&&input.selectionDirection==='backward'?start:end
    c.font='22px "Segoe UI","Microsoft YaHei",sans-serif'
    const measure=index=>c.measureText(ed.text.slice(0,index)).width,caretX=measure(caret),visible=f.w-30
    let scroll=ed.numberScroll||0
    if(caretX-scroll>visible)scroll=caretX-visible
    if(caretX-scroll<0)scroll=caretX
    ed.numberScroll=Math.max(0,scroll)
    c.save();c.beginPath();c.rect(f.x+12,f.y+5,f.w-24,f.h-10);c.clip()
    const left=f.x+14-ed.numberScroll
    if(start!==end){c.fillStyle='#cce0ff';c.fillRect(left+measure(start),f.y+12,measure(end)-measure(start),30)}
    this.text(ed.text,left,f.y+27,22,'#25334a')
    if(start===end&&(performance.now()-(ed.caretTime||0)<550||Math.floor(performance.now()/550)%2===0)){c.fillStyle='#286ed4';c.fillRect(left+caretX,f.y+13,1.5,28)}
    c.restore();this.buttons=[]
    if(ed.error)this.fitText(ed.error,x+24,y+188,w-48,11,'#bf4b4b')
    this.button(x+w-194,y+h-56,78,34,'取消',()=>this.cancelMaterialEditor())
    this.button(x+w-104,y+h-56,80,34,'确认数字',()=>this.commitEditor(),true)
    this.buttons.push({x:x+w-48,y:y+12,w:36,h:36,fn:()=>this.cancelMaterialEditor()});this.text('×',x+w-30,y+30,22,'#8590a0','center')
    c.restore()
  }
  drawMaterialEditor(){
    if(this.editor.b.type==='source.number'){this.drawNumberEditor();return}

    const ed=this.editor,c=this.c,numeric=ed.b.type==='source.number',w=Math.min(numeric?420:540,this.w-28),h=Math.min(numeric?506:410,this.h-28),x=(this.w-w)/2,y=(this.h-h)/2
    this.editorBounds={x,y,w,h}
    c.save();c.fillStyle='#24352b88';c.fillRect(0,0,this.w,this.h);c.shadowColor='#1c352633';c.shadowBlur=35;c.shadowOffsetY=14;this.rect(x,y,w,h,'#fcfdf8',20);c.shadowBlur=0;c.shadowOffsetY=0
    this.rect(x+22,y+23,43,43,numeric?'#e0eaf1':'#edf0da',12);drawMachineIcon(c,ed.b.type,x+43.5,y+44.5,27)
    this.text(numeric?'设定数字物料':'写下文字物料',x+80,y+37,20,'#405a37','left',700)
    const fieldY=y+(numeric&&h<420?72:88),fieldH=numeric?(h<420?50:70):Math.max(90,h-198)
    this.rect(x+22,fieldY,w-44,fieldH,'#f0f4e9',11,'#b8cda7')
    c.save();c.beginPath();c.rect(x+30,fieldY+8,w-60,fieldH-16);c.clip()
    if(numeric)this.fitText(ed.text||'0',x+w-40,fieldY+fieldH/2,w-80,34,'#536e42','right')
    else{
      for(let yy=fieldY+34;yy<fieldY+fieldH-8;yy+=25){c.strokeStyle='#e1e8d8';c.lineWidth=1;c.beginPath();c.moveTo(x+38,yy);c.lineTo(x+w-38,yy);c.stroke()}
      this.wrap(ed.text+(Math.floor(performance.now()/550)%2?'':'▏'),x+38,fieldY+24,w-76,16,Math.max(1,Math.floor((fieldH-24)/23)))
    }
    c.restore();this.buttons=[]
    this.buttons.push({x:x+22,y:fieldY,w:w-44,h:fieldH,fn:()=>this.focusMaterialInput()})
    if(numeric){
      const keys=['7','8','9','4','5','6','1','2','3','±','0','.'],gap=7,keyH=Math.max(24,Math.min(43,(h-249)/4)),keyW=(w-58)/3
      keys.forEach((label,index)=>this.button(x+22+index%3*(keyW+gap),fieldY+fieldH+13+Math.floor(index/3)*(keyH+gap),keyW,keyH,label,()=>{let text=ed.replace?'':ed.text;if(label==='±')text=text.startsWith('-')?text.slice(1):'-'+text;else if(label!=='.'||!text.includes('.'))text+=label;this.setMaterialText(text)}))
      this.buttons.push({x:x+w-79,y:y+21,w:57,h:38,fn:()=>this.setMaterialText(ed.text.slice(0,-1))});this.text('⌫',x+w-49,y+40,20,'#8c9b7e','center')
    }
    if(ed.error)this.fitText(ed.error,x+23,y+h-78,w-46,10,'#b66651')
    this.button(x+22,y+h-57,(w-53)/2,36,'取消',()=>this.cancelMaterialEditor())
    this.button(x+31+(w-53)/2,y+h-57,(w-53)/2,36,numeric?'确认数字':'确认文字',()=>this.commitEditor(),true)
    c.restore()
  }
  drawEditor(){
    if(this.editor.b.type==='source.number'||this.editor.b.type==='source.string'){this.drawMaterialEditor();return}
    const ed=this.editor,w=Math.min(560,this.w-24),x=(this.w-w)/2,h=Math.min(460,this.h-24),y=(this.h-h)/2
    this.c.fillStyle='#293e3088';this.c.fillRect(0,0,this.w,this.h);this.rect(x,y,w,h,'#fbfcf7',16)
    this.text(appearance(ed.b.type).name+' · 配方单',x+20,y+29,17,'#4b633b','left',600)
    this.fitText(appearance(ed.b.type).hint,x+20,y+58,w-40,11)
    this.buttons=[]
    const rowH=Math.min(112,(h-160)/Math.max(1,ed.fields.length))
    if(!ed.fields.length)this.text('这台设备按固定工艺运行，无需调整。',x+20,y+116,13)
    ed.fields.forEach((f,i)=>{
      const top=y+80+i*rowH,active=ed.active===i
      this.fitText(f.label,x+20,top,w-40,11)
      this.rect(x+16,top+12,w-32,rowH-28,active?'#e5eedb':'#edf1e7',8,'#c8d7b9')
      const label=f.value+(active&&f.kind!=='choice'?' ▏':'')
      this.wrap(label,x+25,top+31,w-55,13,Math.max(1,Math.floor((rowH-54)/20)))
      this.buttons.push({x:x+16,y:top+12,w:w-32,h:rowH-28,fn:()=>{ed.active=i;ed.replace=true;if(f.kind==='choice')f.value=f.options[(f.options.indexOf(f.value)+1)%f.options.length]}})
      if(f.kind==='choice')this.text('点击切换 ›',x+w-28,top,10,'#819773','right')
    })
    this.fitText(ed.error||'点击选择填写处 · Tab 切换 · Shift+Enter 换行 · Enter 完成',x+20,y+h-80,w-40,10,ed.error?'#b45d48':'#859778')
    this.button(x+20,y+h-53,(w-48)/2,34,'取消',()=>{this.editor=null});this.button(x+28+(w-48)/2,y+h-53,(w-48)/2,34,'确认配方',()=>this.commitEditor(),true)
  }
  destroy(){this.saveSlots?.flush();this.saveSlots?.removeInput();this.cloud?.destroy();if(this.materialInput)this.materialInput.remove();cancelAnimationFrame(this.frame);clearInterval(this.configTimer);this.events.forEach(fn=>fn())}
}
